export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** AIFilterRegex */
  AIFilterRegex: { input: string; output: string; }
  /** Integer beyond the 32-bit range, limited to ±(2^53 - 1) and serialized as a number */
  BigInt: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: string; output: string; }
  /** JSON string */
  JSON: { input: any; output: any; }
  /** Lexical JSON */
  LexicalJSON: { input: any; output: any; }
  /** ULID */
  ULID: { input: string; output: string; }
  /** UUID */
  UUID: { input: string; output: string; }
};

export type AiFilter = {
  __typename?: 'AIFilter';
  collections: Array<CustomCollection>;
  id: Scalars['ID']['output'];
  /** @deprecated Ignored. AI filters run on Synoptic infrastructure. */
  model: Scalars['String']['output'];
  name: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
};

export const AiFilterAssistantResponseType = {
  ClarificationRequired: 'CLARIFICATION_REQUIRED',
  Complete: 'COMPLETE'
} as const;

export type AiFilterAssistantResponseType = typeof AiFilterAssistantResponseType[keyof typeof AiFilterAssistantResponseType];
export type AiFilterInput = {
  /** @deprecated Ignored. AI filters run on Synoptic infrastructure. */
  model?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
};

export type AiFilterSuggestion = {
  __typename?: 'AIFilterSuggestion';
  chatId: Scalars['ID']['output'];
  prompt: Scalars['String']['output'];
  responseType: AiFilterAssistantResponseType;
};

/** Input for testing an AI filter */
export type AiFilterTestInput = {
  /**
   * The model to use for the filter
   * @deprecated Ignored. AI filters run on Synoptic infrastructure.
   */
  model?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
};

export type AddCustomCollectionInput = {
  filters: CustomCollectionFilterConfigInput;
  highlights?: InputMaybe<CustomCollectionHighlightInput>;
  matchingSourcesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  sources: Array<CustomCollectionSourceInput>;
  streamDeckId: Scalars['ULID']['input'];
};

export type AddStreamDeckInput = {
  name: Scalars['String']['input'];
};

export type AddTargetsToCustomCollectionsInput = {
  collections: Array<CustomCollectionRefInput>;
  streamId: Scalars['ID']['input'];
  targets: Array<Scalars['String']['input']>;
};

export type AddTerminalTabInput = {
  configuration: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type AddUsersToOrganizationInput = {
  organizationId: Scalars['ID']['input'];
  role?: OrganizationRoles;
  userIds: Array<Scalars['ID']['input']>;
};

export type AdminAdjustPointsResult = {
  __typename?: 'AdminAdjustPointsResult';
  newBalance: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type AdminAdjustRewardPointsInput = {
  amount: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type AllStreamsPostsSearchInput = {
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  streamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ApiKeyCanReadInput = {
  mode: ApiKeyCanReadMode;
  streamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export const ApiKeyCanReadMode = {
  All: 'ALL',
  Specific: 'SPECIFIC'
} as const;

export type ApiKeyCanReadMode = typeof ApiKeyCanReadMode[keyof typeof ApiKeyCanReadMode];
export type ApiKeyPermissionsObject = {
  __typename?: 'ApiKeyPermissionsObject';
  canPublish: Array<Stream>;
  canPublishSources: Array<Scalars['ID']['output']>;
  canPublishTimeSeries: Array<Scalars['ID']['output']>;
  canRead: Array<Stream>;
  canReadAll: Scalars['Boolean']['output'];
};

export type BottomAction = {
  __typename?: 'BottomAction';
  href: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CompletedMilestone = {
  __typename?: 'CompletedMilestone';
  completedAt: Scalars['String']['output'];
  pointsAwarded: Scalars['Int']['output'];
  type: LearningMilestoneType;
};

export type CreateSourceInput = {
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateStreamInvitesInput = {
  emails: Array<Scalars['String']['input']>;
  inviteeIds: Array<Scalars['ID']['input']>;
  streamId: Scalars['ID']['input'];
};

export type CustomCollection = Node & {
  __typename?: 'CustomCollection';
  columnWidth?: Maybe<Scalars['Int']['output']>;
  filters: CustomCollectionFilterConfig;
  highlights?: Maybe<CustomCollectionHighlight>;
  id: Scalars['ID']['output'];
  isRelatedNews: Scalars['Boolean']['output'];
  matchingSourcesOnly: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sourceConfigs: Array<CustomCollectionSourceConfig>;
  sources: Array<Stream>;
};

export type CustomCollectionFilterConfig = {
  __typename?: 'CustomCollectionFilterConfig';
  ai?: Maybe<AiFilter>;
  excludeKeywords?: Maybe<CustomCollectionKeywordFilterConfig>;
  highlightColor?: Maybe<Scalars['String']['output']>;
  includeKeywords?: Maybe<CustomCollectionKeywordFilterConfig>;
  isHighlightEnabled?: Maybe<Scalars['Boolean']['output']>;
  regex?: Maybe<Scalars['String']['output']>;
};

export type CustomCollectionFilterConfigInput = {
  ai?: InputMaybe<Scalars['ULID']['input']>;
  excludeKeywords?: InputMaybe<CustomCollectionKeywordFilterConfigInput>;
  highlightColor?: InputMaybe<Scalars['String']['input']>;
  includeKeywords?: InputMaybe<CustomCollectionKeywordFilterConfigInput>;
  isHighlightEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  regex?: InputMaybe<Scalars['AIFilterRegex']['input']>;
};

export type CustomCollectionHighlight = {
  __typename?: 'CustomCollectionHighlight';
  isEnabled: Scalars['Boolean']['output'];
  values: Array<CustomCollectionHighlightValue>;
};

export type CustomCollectionHighlightInput = {
  isEnabled: Scalars['Boolean']['input'];
  values: Array<CustomCollectionHighlightValueInput>;
};

export type CustomCollectionHighlightValue = {
  __typename?: 'CustomCollectionHighlightValue';
  color: Scalars['String']['output'];
  regex: Scalars['String']['output'];
};

export type CustomCollectionHighlightValueInput = {
  color: Scalars['String']['input'];
  regex: Scalars['String']['input'];
};

export type CustomCollectionKeywordFilterConfig = {
  __typename?: 'CustomCollectionKeywordFilterConfig';
  all?: Maybe<Scalars['String']['output']>;
  any?: Maybe<Scalars['String']['output']>;
  phrase?: Maybe<Scalars['String']['output']>;
};

export type CustomCollectionKeywordFilterConfigInput = {
  all?: InputMaybe<Scalars['String']['input']>;
  any?: InputMaybe<Scalars['String']['input']>;
  phrase?: InputMaybe<Scalars['String']['input']>;
};

export type CustomCollectionPostUpdate = {
  __typename?: 'CustomCollectionPostUpdate';
  post: StreamPost;
};

export type CustomCollectionPostsInput = {
  collectionId: Scalars['ID']['input'];
  limit?: Scalars['Int']['input'];
  matchFilter?: InputMaybe<PostMatchFilterInput>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  streamDeckId: Scalars['ID']['input'];
};

export type CustomCollectionPostsPage = {
  __typename?: 'CustomCollectionPostsPage';
  items: Array<StreamPost>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type CustomCollectionRefInput = {
  id: Scalars['ULID']['input'];
  streamDeckId: Scalars['ULID']['input'];
};

export type CustomCollectionSourceConfig = {
  __typename?: 'CustomCollectionSourceConfig';
  customTargets: Array<Scalars['String']['output']>;
  excludedPostTypes: Array<StreamPostType>;
  sourceIds: Array<Scalars['ID']['output']>;
  stream: Stream;
  usesAllTargets: Scalars['Boolean']['output'];
};

export type CustomCollectionSourceInput = {
  customTargets?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Post types to leave out of this stream. Null or empty keeps every type. */
  excludedPostTypes?: InputMaybe<Array<StreamPostType>>;
  /** Subset of the stream sources (StreamSource.sourceId) to include. Null or empty includes every source. */
  sourceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  streamId: Scalars['ID']['input'];
};

export type CustomTargetsCheckoutData = {
  quantity: Scalars['Int']['input'];
};

export type CustomTargetsData = {
  __typename?: 'CustomTargetsData';
  maxTargets: Scalars['Int']['output'];
  maxTotalTargets?: Maybe<Scalars['Int']['output']>;
  minTargets: Scalars['Int']['output'];
  stepSize: Scalars['Int']['output'];
  targetType: Scalars['String']['output'];
  targetTypeInstruction: Scalars['String']['output'];
  targetValidationRegex?: Maybe<Scalars['String']['output']>;
};

export type CustomTargetsDataInput = {
  maxTargets: Scalars['Int']['input'];
  maxTotalTargets?: InputMaybe<Scalars['Int']['input']>;
  minTargets: Scalars['Int']['input'];
  stepSize: Scalars['Int']['input'];
  targetType: Scalars['String']['input'];
  targetTypeInstruction: Scalars['String']['input'];
  targetValidationRegex?: InputMaybe<Scalars['String']['input']>;
};

export type DiscussionFeedInput = {
  discussionContextId: Scalars['ID']['input'];
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: Order;
};

export type DiscussionPage = {
  __typename?: 'DiscussionPage';
  items: Array<DiscussionPost>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type DiscussionPost = IPost & Node & {
  __typename?: 'DiscussionPost';
  author: User;
  authorId: Scalars['ID']['output'];
  comments: DiscussionPage;
  commentsCount: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  discussionContextId: Scalars['ID']['output'];
  discussionContextStream?: Maybe<Stream>;
  discussionLevel: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  json?: Maybe<Scalars['String']['output']>;
  markdown?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Array<S3Object>>;
  parentDiscussionPostId?: Maybe<Scalars['ID']['output']>;
  text: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};


export type DiscussionPostCommentsArgs = {
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type DiscussionPostInput = {
  discussionContextId: Scalars['ID']['input'];
  json?: InputMaybe<Scalars['String']['input']>;
  markdown?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<S3ObjectInput>>;
  parentDiscussionPostId?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
};

export type EnrichmentInvocation = {
  __typename?: 'EnrichmentInvocation';
  error?: Maybe<Scalars['String']['output']>;
  inputBytes: Scalars['Int']['output'];
  inputPreview: Scalars['String']['output'];
  latencyMs: Scalars['Int']['output'];
  outcome: EnrichmentInvocationOutcome;
  postId?: Maybe<Scalars['String']['output']>;
  responseBytes: Scalars['Int']['output'];
  resultPreview?: Maybe<Scalars['String']['output']>;
  service: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  ts: Scalars['String']['output'];
};

export const EnrichmentInvocationOutcome = {
  BreakerOpen: 'breaker_open',
  Error: 'error',
  Ok: 'ok',
  Shed: 'shed',
  Timeout: 'timeout'
} as const;

export type EnrichmentInvocationOutcome = typeof EnrichmentInvocationOutcome[keyof typeof EnrichmentInvocationOutcome];
export type EnrichmentInvocationPage = {
  __typename?: 'EnrichmentInvocationPage';
  items: Array<EnrichmentInvocation>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type EnrichmentInvocationsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  outcome?: InputMaybe<EnrichmentInvocationOutcome>;
  service?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type EnrichmentLatencyBands = {
  __typename?: 'EnrichmentLatencyBands';
  gt3000: Scalars['Int']['output'];
  le100: Scalars['Int']['output'];
  le250: Scalars['Int']['output'];
  le500: Scalars['Int']['output'];
  le1000: Scalars['Int']['output'];
  le2000: Scalars['Int']['output'];
  le3000: Scalars['Int']['output'];
};

export type EnrichmentLatencyBucket = {
  __typename?: 'EnrichmentLatencyBucket';
  approxP95Ms?: Maybe<Scalars['Float']['output']>;
  avgMs: Scalars['Float']['output'];
  bands: EnrichmentLatencyBands;
  bucketStart: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  maxMs: Scalars['Int']['output'];
  outcomes: EnrichmentLatencyOutcomes;
};

export type EnrichmentLatencyBucketsInput = {
  from: Scalars['String']['input'];
  service?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
};

export type EnrichmentLatencyOutcomes = {
  __typename?: 'EnrichmentLatencyOutcomes';
  breakerOpen: Scalars['Int']['output'];
  error: Scalars['Int']['output'];
  ok: Scalars['Int']['output'];
  shed: Scalars['Int']['output'];
  timeout: Scalars['Int']['output'];
};

export type EnrichmentService = {
  __typename?: 'EnrichmentService';
  createdAt: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  maxResponseBytes: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  secretArn?: Maybe<Scalars['String']['output']>;
  timeoutMs: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type EnrichmentServiceName = {
  __typename?: 'EnrichmentServiceName';
  name: Scalars['String']['output'];
};

export type EnrichmentsObject = {
  __typename?: 'EnrichmentsObject';
  polymatcher?: Maybe<Array<Scalars['String']['output']>>;
  translate?: Maybe<Scalars['String']['output']>;
};

export type EnterpriseNodeData = {
  __typename?: 'EnterpriseNodeData';
  az: Scalars['String']['output'];
  ip: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type EnterpriseStreamPost = {
  __typename?: 'EnterpriseStreamPost';
  createdAt: Scalars['String']['output'];
  leaf: EnterpriseNodeData;
  pk: Scalars['String']['output'];
  post: EnterpriseStreamPostData;
  root: EnterpriseNodeData;
  sk: Scalars['String']['output'];
  streamId: Scalars['String']['output'];
};

export type EnterpriseStreamPostData = {
  __typename?: 'EnterpriseStreamPostData';
  idempotencyKey: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type EnterpriseStreamPostsInput = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  leafAz?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type EnterpriseStreamPostsPage = {
  __typename?: 'EnterpriseStreamPostsPage';
  items: Array<EnterpriseStreamPost>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export const Exchange = {
  BinancePerps: 'BINANCE_PERPS',
  BinanceSpot: 'BINANCE_SPOT',
  BybitPerps: 'BYBIT_PERPS',
  BybitSpot: 'BYBIT_SPOT',
  HypePerps: 'HYPE_PERPS',
  HypeSpot: 'HYPE_SPOT',
  Kalshi: 'KALSHI',
  Polymarket: 'POLYMARKET'
} as const;

export type Exchange = typeof Exchange[keyof typeof Exchange];
export type ExchangePairInput = {
  exchange: Exchange;
  value: Scalars['String']['input'];
};

export type ExchangePairObject = {
  __typename?: 'ExchangePairObject';
  exchange: Exchange;
  value: Scalars['String']['output'];
};

export type ExportEnterpriseStreamPostsInput = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  leafAz?: InputMaybe<Scalars['String']['input']>;
  streamId: Scalars['ID']['input'];
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type ExportStreamPostsInput = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  streamId: Scalars['ID']['input'];
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type Flag = {
  __typename?: 'Flag';
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type GenerateApiKeyInput = {
  canPublish?: Array<Scalars['ID']['input']>;
  canPublishSources?: Array<Scalars['ID']['input']>;
  canRead: ApiKeyCanReadInput;
  keyName?: InputMaybe<Scalars['String']['input']>;
};

export type HoldStreamInput = {
  description: Scalars['String']['input'];
};

export type IOffsetPage = {
  items: Array<Node>;
  offset?: Maybe<Scalars['Int']['output']>;
};

export type IPost = {
  authorId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  media?: Maybe<Array<S3Object>>;
  text: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type IconInput = {
  url: Scalars['String']['input'];
};

export type IconObject = {
  __typename?: 'IconObject';
  url: Scalars['String']['output'];
};

export type InAppNotificationContent = {
  __typename?: 'InAppNotificationContent';
  bottomActions?: Maybe<Array<BottomAction>>;
  htmlBody?: Maybe<Scalars['String']['output']>;
  htmlTitle?: Maybe<Scalars['String']['output']>;
  image?: Maybe<NotificationImage>;
  jsonBody?: Maybe<Scalars['JSON']['output']>;
  toggleFollowUserButton?: Maybe<ToggleFollowUserButton>;
};

export type KeysInput = {
  auth: Scalars['String']['input'];
  p256dh: Scalars['String']['input'];
};

export type KeysType = {
  __typename?: 'KeysType';
  auth: Scalars['String']['output'];
  p256dh: Scalars['String']['output'];
};

export type LearningMilestoneInfo = {
  __typename?: 'LearningMilestoneInfo';
  completed: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  pointsReward: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  type: LearningMilestoneType;
};

export const LearningMilestoneType = {
  FirstPurchase: 'FIRST_PURCHASE',
  FirstStreamdeckList: 'FIRST_STREAMDECK_LIST',
  VideoWatched: 'VIDEO_WATCHED'
} as const;

export type LearningMilestoneType = typeof LearningMilestoneType[keyof typeof LearningMilestoneType];
export type LearningProgress = {
  __typename?: 'LearningProgress';
  availableMilestones: Array<LearningMilestoneInfo>;
  availablePoints: Scalars['Int']['output'];
  completedMilestones: Array<CompletedMilestone>;
  videos: Array<LearningVideo>;
};

export type LearningVideo = {
  __typename?: 'LearningVideo';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  pointsReward: Scalars['Int']['output'];
  s3Key: Scalars['String']['output'];
  title: Scalars['String']['output'];
  watched: Scalars['Boolean']['output'];
};

export type MarketBlacklistEntry = {
  __typename?: 'MarketBlacklistEntry';
  /** Human readable name captured when the entry was added */
  label?: Maybe<Scalars['String']['output']>;
  platform: MarketBlacklistPlatform;
  scope: MarketBlacklistScope;
  /** Polymarket condition id, event slug or tag label; Kalshi market ticker or event ticker */
  value: Scalars['String']['output'];
};

export type MarketBlacklistEntryInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  platform: MarketBlacklistPlatform;
  scope: MarketBlacklistScope;
  value: Scalars['String']['input'];
};

export const MarketBlacklistPlatform = {
  Kalshi: 'KALSHI',
  Polymarket: 'POLYMARKET'
} as const;

export type MarketBlacklistPlatform = typeof MarketBlacklistPlatform[keyof typeof MarketBlacklistPlatform];
export const MarketBlacklistScope = {
  Event: 'EVENT',
  Market: 'MARKET',
  Tag: 'TAG'
} as const;

export type MarketBlacklistScope = typeof MarketBlacklistScope[keyof typeof MarketBlacklistScope];
export const MarketGreenlistMode = {
  /** Only markets carrying a greenlisted tag are shown */
  Only: 'ONLY',
  /** Every market is shown unless blacklisted; a greenlisted tag outweighs a blacklisted one */
  Override: 'OVERRIDE'
} as const;

export type MarketGreenlistMode = typeof MarketGreenlistMode[keyof typeof MarketGreenlistMode];
export type MediaItemInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  credit?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type MediaItemObject = {
  __typename?: 'MediaItemObject';
  caption?: Maybe<Scalars['String']['output']>;
  credit?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type MediaUploadUrl = {
  __typename?: 'MediaUploadUrl';
  /** Object key suffix echoed back from the request */
  key: Scalars['String']['output'];
  /** Pre-signed S3 PUT URL, valid for 60 minutes */
  url: Scalars['String']['output'];
};

export type MediaUploadUrlInput = {
  /** file mime type */
  contentType: Scalars['String']['input'];
  /** Object key suffix (without the server-enforced prefix) */
  key: Scalars['String']['input'];
};

export type MetadataInput = {
  headline?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<IconInput>;
  machineReadableText?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<MediaItemInput>>;
  pairs?: InputMaybe<Array<ExchangePairInput>>;
  sourceLink?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  sourceTimestamp?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  targetRejectReason?: InputMaybe<Scalars['String']['input']>;
  targetUnRejectReason?: InputMaybe<Scalars['String']['input']>;
  tickers?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataObject = {
  __typename?: 'MetadataObject';
  headline?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<IconObject>;
  machineReadableText?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Array<MediaItemObject>>;
  pairs?: Maybe<Array<ExchangePairObject>>;
  sourceLink?: Maybe<Scalars['String']['output']>;
  sourceName?: Maybe<Scalars['String']['output']>;
  sourceTimestamp?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tickers?: Maybe<Array<Scalars['String']['output']>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  OpticFeedsTwttrMutation: OpticFeedsTwttrMutation;
  acceptPrivacyPolicy: User;
  acceptTermsOfService: User;
  activateStream: Stream;
  addAIFilter: AiFilter;
  addCustomCollection: CustomCollection;
  addDiscussionPost: DiscussionPost;
  addMatchingNewsList: CustomCollection;
  addOrganization: OrganizationObject;
  addPushNotificationsSubscription: Scalars['Boolean']['output'];
  addSourceRoute: Source;
  addSourceToApiKey: StreamApiKey;
  addStream: Stream;
  addStreamDeck: StreamDeck;
  addStreamPackage: StreamPackage;
  addStreamPost: StreamPost;
  addStreamToApiKey: StreamApiKey;
  addTargetsToCustomCollections: Array<CustomCollection>;
  addTerminalTab: TerminalTab;
  addTimeSeriesRoute: TimeSeries;
  addTimeSeriesToApiKey: StreamApiKey;
  addUserToEarlyAccessTerminal: Scalars['Boolean']['output'];
  addUsersToOrganization: Array<User>;
  addUsersToStream: Array<User>;
  adminAdjustRewardPoints: AdminAdjustPointsResult;
  aiFilterWithAssistant: AiFilterSuggestion;
  claimSignupStreamSubscription: Scalars['Boolean']['output'];
  createSource: Source;
  createStreamInvites: Array<StreamInvite>;
  createStripeSellerAccount: StripeSellerAccount;
  createTimeSeries: TimeSeries;
  deactivateStream: Stream;
  deleteEnrichmentService: Scalars['Boolean']['output'];
  deleteOrganization: Scalars['Boolean']['output'];
  deleteSource: Scalars['Boolean']['output'];
  deleteStream: Scalars['Boolean']['output'];
  deleteStreamPackage: Scalars['Boolean']['output'];
  deleteTimeSeries: Scalars['Boolean']['output'];
  ensureRelatedNewsList: CustomCollection;
  follow: Scalars['Boolean']['output'];
  followStream: Scalars['Boolean']['output'];
  generateApiKey: Scalars['String']['output'];
  generatePossibleUsernames: Array<Scalars['String']['output']>;
  /** Creates an API key that can publish points to this series. */
  generateTimeSeriesApiKey: Scalars['String']['output'];
  holdStream: Stream;
  markLearningVideoWatched: LearningProgress;
  mediaUploadUrl: MediaUploadUrl;
  polymatcherExplain: PolymatcherExplainResult;
  polymatcherRefreshUserActions: PolymatcherUserActionRefreshReport;
  polymatcherSetLabel: PolymatcherSetLabelResult;
  polymatcherSetManualLabel: PolymatcherSetLabelResult;
  polymatcherSetUserActionLabel: PolymatcherSetLabelResult;
  publishStream: Stream;
  readNotification: Notification;
  redeemLearningPoints: RedeemPointsResult;
  regenerateApiKey: Scalars['String']['output'];
  removeAIFilter: Scalars['Boolean']['output'];
  removeCustomCollection: Scalars['Boolean']['output'];
  removePushNotificationsSubscription: Scalars['Boolean']['output'];
  removeSourceFromApiKey: StreamApiKey;
  removeSourceRoute: Source;
  removeStreamDeck: Scalars['Boolean']['output'];
  removeStreamFromApiKey: StreamApiKey;
  removeTerminalTab: Scalars['Boolean']['output'];
  removeTimeSeriesFromApiKey: StreamApiKey;
  /** Allowed for the series owner and for the stream author. */
  removeTimeSeriesRoute: Scalars['Boolean']['output'];
  removeUserFromEarlyAccessTerminal: Scalars['Boolean']['output'];
  removeUserFromOrganization: Scalars['Boolean']['output'];
  removeUserFromStream: User;
  removeXComHandle: User;
  renameApiKey: StreamApiKey;
  requestTerminalAccess: User;
  resolveStreamInvite: Scalars['Boolean']['output'];
  reviewVoxFullAccessRequest: VoxFullAccessRequest;
  revokeStreamApiKey: Scalars['Boolean']['output'];
  savePostMarketAddMarketSignal: PostMarketAddMarketSignal;
  savePostMarketButtonSignal: PostMarketSignal;
  setAuthorHighlighted: User;
  setCustomCollectionColumnWidth: CustomCollection;
  setEnrichmentServiceEnabled: EnrichmentService;
  /** Live play/pause. Idempotent. Paused routes persist source posts and ACK valid, but forward nothing. */
  setSourceRoutePaused: SourceRoute;
  setStreamCustomTargets: Array<Scalars['String']['output']>;
  setStreamFeatured: Stream;
  setStreamFollowExpiration: Scalars['Boolean']['output'];
  setStreamPackageFeatured: StreamPackage;
  setTerminalVolumeLeaderboardEntry: Scalars['Boolean']['output'];
  setTerminalVolumeLeaderboardHidden: Scalars['Boolean']['output'];
  setUserNewsDeckEnabled: Scalars['Boolean']['output'];
  setUsername: User;
  setXComHandle: User;
  streamPackageSubscriptionCancel: StreamPackageSubscription;
  streamPackageSubscriptionCheckout: SubscriptionCheckout;
  streamSignupTrialUpgradeCheckout: SubscriptionCheckout;
  streamSubscriptionCancel: StreamSubscription;
  streamSubscriptionCheckout: SubscriptionCheckout;
  streamSubscriptionUpdate: Scalars['Boolean']['output'];
  submitVoxFullAccessRequest: VoxFullAccessRequest;
  unfollow: Scalars['Boolean']['output'];
  unfollowStream: Scalars['Boolean']['output'];
  updateAIFilter: AiFilter;
  updateApiKeyPermissions: StreamApiKey;
  updateCustomCollection: CustomCollection;
  updateCustomCollectionSortOrder: Array<Scalars['String']['output']>;
  updateGeneralNotificationSettings: UserSettings;
  updateOrganization: OrganizationObject;
  updateSettings: UserSettings;
  updateSource: Source;
  /** Updates a route. delayMs is replaced on every call (omitting it clears the delay); enterprise is only changed when provided; enrichments only when provided (empty array clears). */
  updateSourceRoute: Source;
  updateStream: Stream;
  updateStreamDeck: StreamDeck;
  updateStreamDeckSortOrder: Array<Scalars['String']['output']>;
  updateStreamPackage: StreamPackage;
  updateTerminalSettings: TerminalSettings;
  updateTerminalTab: TerminalTab;
  updateTerminalTabSortOrder: Array<Scalars['String']['output']>;
  updateTimeSeries: TimeSeries;
  updateUser: User;
  upsertEnrichmentService: EnrichmentService;
  voxSubscriptionCancel: VoxSubscription;
  voxSubscriptionCheckout: SubscriptionCheckout;
  voxSubscriptionUpgrade: VoxSubscription;
};


export type MutationActivateStreamArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAddAiFilterArgs = {
  input: AiFilterInput;
};


export type MutationAddCustomCollectionArgs = {
  input: AddCustomCollectionInput;
};


export type MutationAddDiscussionPostArgs = {
  input: DiscussionPostInput;
};


export type MutationAddMatchingNewsListArgs = {
  streamDeckId: Scalars['ULID']['input'];
};


export type MutationAddOrganizationArgs = {
  input: OrganizationInput;
};


export type MutationAddPushNotificationsSubscriptionArgs = {
  input: PushNotificationSubscriptionInput;
};


export type MutationAddSourceRouteArgs = {
  delayMs?: InputMaybe<Scalars['Int']['input']>;
  discordWebhook?: InputMaybe<Scalars['String']['input']>;
  enrichments?: InputMaybe<Array<SourceRouteEnrichmentInput>>;
  enterprise?: InputMaybe<Scalars['Boolean']['input']>;
  paused?: InputMaybe<Scalars['Boolean']['input']>;
  sourceId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
  wsMarkdownTemplate?: InputMaybe<Scalars['String']['input']>;
  wsMetadataTemplate?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddSourceToApiKeyArgs = {
  apiKeyId: Scalars['ID']['input'];
  sourceId: Scalars['ID']['input'];
};


export type MutationAddStreamArgs = {
  input: StreamInput;
};


export type MutationAddStreamDeckArgs = {
  input: AddStreamDeckInput;
};


export type MutationAddStreamPackageArgs = {
  input: StreamPackageInput;
};


export type MutationAddStreamPostArgs = {
  input: StreamPostInput;
};


export type MutationAddStreamToApiKeyArgs = {
  apiKeyId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
};


export type MutationAddTargetsToCustomCollectionsArgs = {
  input: AddTargetsToCustomCollectionsInput;
};


export type MutationAddTerminalTabArgs = {
  input: AddTerminalTabInput;
};


export type MutationAddTimeSeriesRouteArgs = {
  seriesId: Scalars['UUID']['input'];
  streamId: Scalars['ID']['input'];
};


export type MutationAddTimeSeriesToApiKeyArgs = {
  apiKeyId: Scalars['ID']['input'];
  seriesId: Scalars['UUID']['input'];
};


export type MutationAddUserToEarlyAccessTerminalArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationAddUsersToOrganizationArgs = {
  input: AddUsersToOrganizationInput;
};


export type MutationAddUsersToStreamArgs = {
  streamId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};


export type MutationAdminAdjustRewardPointsArgs = {
  input: AdminAdjustRewardPointsInput;
};


export type MutationAiFilterWithAssistantArgs = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  prompt: Scalars['String']['input'];
};


export type MutationCreateSourceArgs = {
  input: CreateSourceInput;
};


export type MutationCreateStreamInvitesArgs = {
  input: CreateStreamInvitesInput;
};


export type MutationCreateTimeSeriesArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  streamId?: InputMaybe<Scalars['ID']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeactivateStreamArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEnrichmentServiceArgs = {
  name: Scalars['String']['input'];
};


export type MutationDeleteOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSourceArgs = {
  sourceId: Scalars['ID']['input'];
};


export type MutationDeleteStreamArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStreamPackageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTimeSeriesArgs = {
  seriesId: Scalars['UUID']['input'];
};


export type MutationEnsureRelatedNewsListArgs = {
  streamDeckId: Scalars['ULID']['input'];
};


export type MutationFollowArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationFollowStreamArgs = {
  streamId: Scalars['ID']['input'];
};


export type MutationGenerateApiKeyArgs = {
  input: GenerateApiKeyInput;
};


export type MutationGenerateTimeSeriesApiKeyArgs = {
  keyName?: InputMaybe<Scalars['String']['input']>;
  seriesId: Scalars['UUID']['input'];
};


export type MutationHoldStreamArgs = {
  id: Scalars['ID']['input'];
  input: HoldStreamInput;
};


export type MutationMarkLearningVideoWatchedArgs = {
  videoId: Scalars['String']['input'];
};


export type MutationMediaUploadUrlArgs = {
  input: MediaUploadUrlInput;
};


export type MutationPolymatcherExplainArgs = {
  input: PolymatcherExplainInput;
};


export type MutationPolymatcherSetLabelArgs = {
  input: PolymatcherSetLabelInput;
};


export type MutationPolymatcherSetManualLabelArgs = {
  input: PolymatcherSetManualLabelInput;
};


export type MutationPolymatcherSetUserActionLabelArgs = {
  input: PolymatcherSetUserActionLabelInput;
};


export type MutationPublishStreamArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReadNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRedeemLearningPointsArgs = {
  points: Scalars['Int']['input'];
};


export type MutationRegenerateApiKeyArgs = {
  apiKeyId: Scalars['ID']['input'];
};


export type MutationRemoveAiFilterArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveCustomCollectionArgs = {
  id: Scalars['ID']['input'];
  streamDeckId: Scalars['ID']['input'];
};


export type MutationRemovePushNotificationsSubscriptionArgs = {
  input: PushNotificationSubscriptionInput;
};


export type MutationRemoveSourceFromApiKeyArgs = {
  apiKeyId: Scalars['ID']['input'];
  sourceId: Scalars['ID']['input'];
};


export type MutationRemoveSourceRouteArgs = {
  routeId: Scalars['ID']['input'];
  sourceId: Scalars['ID']['input'];
};


export type MutationRemoveStreamDeckArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveStreamFromApiKeyArgs = {
  apiKeyId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
};


export type MutationRemoveTerminalTabArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveTimeSeriesFromApiKeyArgs = {
  apiKeyId: Scalars['ID']['input'];
  seriesId: Scalars['UUID']['input'];
};


export type MutationRemoveTimeSeriesRouteArgs = {
  seriesId: Scalars['UUID']['input'];
  streamId: Scalars['ID']['input'];
};


export type MutationRemoveUserFromEarlyAccessTerminalArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationRemoveUserFromOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRemoveUserFromStreamArgs = {
  streamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRenameApiKeyArgs = {
  apiKeyId: Scalars['ID']['input'];
  keyName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResolveStreamInviteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReviewVoxFullAccessRequestArgs = {
  approved: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};


export type MutationRevokeStreamApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSavePostMarketAddMarketSignalArgs = {
  input: PostMarketAddMarketSignalInput;
};


export type MutationSavePostMarketButtonSignalArgs = {
  input: PostMarketButtonSignalInput;
};


export type MutationSetAuthorHighlightedArgs = {
  id: Scalars['ID']['input'];
  isHighlighted: Scalars['Boolean']['input'];
};


export type MutationSetCustomCollectionColumnWidthArgs = {
  input: SetCustomCollectionColumnWidthInput;
};


export type MutationSetEnrichmentServiceEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};


export type MutationSetSourceRoutePausedArgs = {
  paused: Scalars['Boolean']['input'];
  routeId: Scalars['ID']['input'];
  sourceId: Scalars['ID']['input'];
};


export type MutationSetStreamCustomTargetsArgs = {
  id: Scalars['ID']['input'];
  input: SetStreamCustomTargetsInput;
};


export type MutationSetStreamFeaturedArgs = {
  id: Scalars['ID']['input'];
  isFeatured: Scalars['Boolean']['input'];
};


export type MutationSetStreamFollowExpirationArgs = {
  input: SetStreamFollowExpirationInput;
};


export type MutationSetStreamPackageFeaturedArgs = {
  id: Scalars['ID']['input'];
  isFeatured: Scalars['Boolean']['input'];
};


export type MutationSetTerminalVolumeLeaderboardEntryArgs = {
  input: SetTerminalVolumeLeaderboardEntryInput;
};


export type MutationSetTerminalVolumeLeaderboardHiddenArgs = {
  hidden: Scalars['Boolean']['input'];
};


export type MutationSetUserNewsDeckEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationSetUsernameArgs = {
  username: Scalars['String']['input'];
};


export type MutationSetXComHandleArgs = {
  code: Scalars['String']['input'];
};


export type MutationStreamPackageSubscriptionCancelArgs = {
  input: StreamPackageSubscriptionCancelInput;
};


export type MutationStreamPackageSubscriptionCheckoutArgs = {
  input: StreamPackageSubscriptionCheckoutInput;
};


export type MutationStreamSignupTrialUpgradeCheckoutArgs = {
  customTargetsCheckoutData: CustomTargetsCheckoutData;
  streamId: Scalars['ID']['input'];
};


export type MutationStreamSubscriptionCancelArgs = {
  input: StreamSubscriptionCancelInput;
};


export type MutationStreamSubscriptionCheckoutArgs = {
  input: StreamSubscriptionCheckoutInput;
};


export type MutationStreamSubscriptionUpdateArgs = {
  customTargetsCheckoutData: CustomTargetsCheckoutData;
  streamId: Scalars['ID']['input'];
};


export type MutationSubmitVoxFullAccessRequestArgs = {
  input: SubmitVoxFullAccessRequestInput;
};


export type MutationUnfollowArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationUnfollowStreamArgs = {
  streamId: Scalars['ID']['input'];
};


export type MutationUpdateAiFilterArgs = {
  id: Scalars['ID']['input'];
  input: AiFilterInput;
};


export type MutationUpdateApiKeyPermissionsArgs = {
  input: UpdateApiKeyPermissionsInput;
};


export type MutationUpdateCustomCollectionArgs = {
  input: UpdateCustomCollectionInput;
};


export type MutationUpdateCustomCollectionSortOrderArgs = {
  sortOrder: Array<Scalars['String']['input']>;
  streamDeckId: Scalars['ID']['input'];
};


export type MutationUpdateGeneralNotificationSettingsArgs = {
  input: UpdateGeneralNotificationSettingsInput;
};


export type MutationUpdateOrganizationArgs = {
  id: Scalars['ID']['input'];
  input: OrganizationInput;
};


export type MutationUpdateSettingsArgs = {
  input: UpdateSettingsInput;
};


export type MutationUpdateSourceArgs = {
  input: UpdateSourceInput;
};


export type MutationUpdateSourceRouteArgs = {
  delayMs?: InputMaybe<Scalars['Int']['input']>;
  discordWebhook?: InputMaybe<Scalars['String']['input']>;
  enrichments?: InputMaybe<Array<SourceRouteEnrichmentInput>>;
  enterprise?: InputMaybe<Scalars['Boolean']['input']>;
  routeId: Scalars['ID']['input'];
  sourceId: Scalars['ID']['input'];
  wsMarkdownTemplate?: InputMaybe<Scalars['String']['input']>;
  wsMetadataTemplate?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateStreamArgs = {
  id: Scalars['ID']['input'];
  input: UpdateStreamInput;
};


export type MutationUpdateStreamDeckArgs = {
  input: UpdateStreamDeckInput;
};


export type MutationUpdateStreamDeckSortOrderArgs = {
  sortOrder: Array<Scalars['String']['input']>;
};


export type MutationUpdateStreamPackageArgs = {
  id: Scalars['ID']['input'];
  input: UpdateStreamPackageInput;
};


export type MutationUpdateTerminalSettingsArgs = {
  input: UpdateTerminalSettingsInput;
};


export type MutationUpdateTerminalTabArgs = {
  input: UpdateTerminalTabInput;
};


export type MutationUpdateTerminalTabSortOrderArgs = {
  sortOrder: Array<Scalars['String']['input']>;
};


export type MutationUpdateTimeSeriesArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  seriesId: Scalars['UUID']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpsertEnrichmentServiceArgs = {
  input: UpsertEnrichmentServiceInput;
};


export type MutationVoxSubscriptionCheckoutArgs = {
  priceId: Scalars['String']['input'];
};

export type MySourcesInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type Notification = Node & {
  __typename?: 'Notification';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inAppNotificationContent?: Maybe<InAppNotificationContent>;
  notificationUserId: Scalars['ID']['output'];
  read: Scalars['Boolean']['output'];
};

export type NotificationImage = {
  __typename?: 'NotificationImage';
  alt: Scalars['String']['output'];
  file?: Maybe<S3Object>;
  href?: Maybe<Scalars['String']['output']>;
};

export const NotificationType = {
  Email: 'EMAIL',
  InApp: 'IN_APP',
  Push: 'PUSH'
} as const;

export type NotificationType = typeof NotificationType[keyof typeof NotificationType];
export type NotificationsInput = {
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationsPage = {
  __typename?: 'NotificationsPage';
  items: Array<Notification>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type NotificationsSettings = {
  __typename?: 'NotificationsSettings';
  EMAIL: Scalars['Boolean']['output'];
  IN_APP: Scalars['Boolean']['output'];
  mentions: Array<NotificationType>;
  newFollowers: Array<NotificationType>;
  streamSubscribers?: Maybe<Array<NotificationType>>;
  subscribedAuthorPost: Array<NotificationType>;
  system: Array<NotificationType>;
};

export type NotificationsSettingsInput = {
  mentions: Array<NotificationType>;
  newFollowers: Array<NotificationType>;
  streamSubscribers?: InputMaybe<Array<NotificationType>>;
  subscribedAuthorPost: Array<NotificationType>;
  system: Array<NotificationType>;
};

export const OnboardingLinkPage = {
  CustomStreams: 'CUSTOM_STREAMS',
  SettingsPayments: 'SETTINGS_PAYMENTS',
  Streams: 'STREAMS',
  StreamPackages: 'STREAM_PACKAGES'
} as const;

export type OnboardingLinkPage = typeof OnboardingLinkPage[keyof typeof OnboardingLinkPage];
export const OnboardingType = {
  DataStreams: 'DataStreams',
  FollowAuthors: 'FollowAuthors',
  Reputation: 'Reputation',
  Synoptic: 'Synoptic',
  Tournaments: 'Tournaments',
  UserInterests: 'UserInterests'
} as const;

export type OnboardingType = typeof OnboardingType[keyof typeof OnboardingType];
export type OpticFeedsTwttrMutation = {
  __typename?: 'OpticFeedsTwttrMutation';
  checkout: TwttrApiCheckout;
};


export type OpticFeedsTwttrMutationCheckoutArgs = {
  prices?: InputMaybe<Array<TwttrApiCheckoutPriceInput>>;
};

export type OpticFeedsTwttrQuery = {
  __typename?: 'OpticFeedsTwttrQuery';
  billingPortalSession: TwttrApiBillingPortalSession;
  prices: Array<TwttrApiPrice>;
  subscriptions: Array<TwttrApiSubscription>;
};

export const Order = {
  Asc: 'ASC',
  Desc: 'DESC'
} as const;

export type Order = typeof Order[keyof typeof Order];
export type OrganizationInput = {
  name: Scalars['String']['input'];
};

export type OrganizationMembership = {
  __typename?: 'OrganizationMembership';
  organization?: Maybe<OrganizationSummary>;
  role?: Maybe<OrganizationRoles>;
};

export type OrganizationObject = {
  __typename?: 'OrganizationObject';
  id: Scalars['ID']['output'];
  maxSeats?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
};

export const OrganizationRoles = {
  Admin: 'ADMIN',
  Member: 'MEMBER'
} as const;

export type OrganizationRoles = typeof OrganizationRoles[keyof typeof OrganizationRoles];
export type OrganizationSummary = {
  __typename?: 'OrganizationSummary';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type OrganizationUsersInput = {
  id: Scalars['ID']['input'];
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationsPage = {
  __typename?: 'OrganizationsPage';
  items: Array<OrganizationObject>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type PaidDataInput = {
  prices: StripePriceInput;
};

export const PolymatcherActionType = {
  Dislike: 'dislike',
  Like: 'like',
  ManualAdd: 'manualAdd',
  Trade: 'trade'
} as const;

export type PolymatcherActionType = typeof PolymatcherActionType[keyof typeof PolymatcherActionType];
export type PolymatcherCandidate = {
  __typename?: 'PolymatcherCandidate';
  at: Scalars['String']['output'];
  inferenceFired: PolymatcherFiredState;
  inferenceId: Scalars['ID']['output'];
  latencyMs?: Maybe<Scalars['Float']['output']>;
  pipelineFired: Scalars['Boolean']['output'];
  postId?: Maybe<Scalars['String']['output']>;
  rank: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
  tau?: Maybe<Scalars['Float']['output']>;
  textLength: Scalars['Int']['output'];
  textPreview: Scalars['String']['output'];
  unitDocText?: Maybe<Scalars['String']['output']>;
  unitId: Scalars['ID']['output'];
  unitQuestion?: Maybe<Scalars['String']['output']>;
};

export type PolymatcherCandidatePage = {
  __typename?: 'PolymatcherCandidatePage';
  items: Array<PolymatcherCandidate>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type PolymatcherCandidateSearchInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  inferenceFired?: InputMaybe<Scalars['Boolean']['input']>;
  marketText?: InputMaybe<Scalars['String']['input']>;
  newsText?: InputMaybe<Scalars['String']['input']>;
  pageSize: Scalars['Int']['input'];
  pipelineFired?: InputMaybe<Scalars['Boolean']['input']>;
  previewLength: Scalars['Int']['input'];
  sort: PolymatcherCandidateSort;
  unitText?: InputMaybe<Scalars['String']['input']>;
  window?: InputMaybe<PolymatcherTimeWindowInput>;
};

export const PolymatcherCandidateSort = {
  DateScore: 'dateScore',
  ScoreAsc: 'scoreAsc',
  ScoreDesc: 'scoreDesc',
  Threshold: 'threshold'
} as const;

export type PolymatcherCandidateSort = typeof PolymatcherCandidateSort[keyof typeof PolymatcherCandidateSort];
export type PolymatcherExplainAnswerMarket = {
  __typename?: 'PolymatcherExplainAnswerMarket';
  conditionId: Scalars['ID']['output'];
  deactivatedAt?: Maybe<Scalars['String']['output']>;
  eventTitle?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
};

export type PolymatcherExplainCandidate = {
  __typename?: 'PolymatcherExplainCandidate';
  ce: Scalars['Float']['output'];
  clearedTau: Scalars['Boolean']['output'];
  docText: Scalars['String']['output'];
  inAnswer: Scalars['Boolean']['output'];
  marketCount: Scalars['Int']['output'];
  ms: Scalars['Float']['output'];
  rank: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
  unitId: Scalars['ID']['output'];
  unitQuestion?: Maybe<Scalars['String']['output']>;
};

export type PolymatcherExplainInput = {
  newsText: Scalars['String']['input'];
};

export type PolymatcherExplainResult = {
  __typename?: 'PolymatcherExplainResult';
  detail?: Maybe<Scalars['String']['output']>;
  run?: Maybe<PolymatcherExplainRun>;
  status: PolymatcherExplainStatus;
};

export type PolymatcherExplainRun = {
  __typename?: 'PolymatcherExplainRun';
  answer: Array<PolymatcherExplainAnswerMarket>;
  candidates: Array<PolymatcherExplainCandidate>;
  capped: Scalars['Boolean']['output'];
  corpusRows: Scalars['Int']['output'];
  corpusVersion: Scalars['String']['output'];
  fired: Scalars['Boolean']['output'];
  latencyMs: Scalars['Float']['output'];
  maxMarkets: Scalars['Int']['output'];
  ranAt: Scalars['String']['output'];
  /** @deprecated the stacker it configured is gone */
  recallTarget?: Maybe<Scalars['String']['output']>;
  retrieverVersion: Scalars['String']['output'];
  roundTripMs: Scalars['Float']['output'];
  scoredChars: Scalars['Int']['output'];
  tau: Scalars['Float']['output'];
  truncated: Scalars['Boolean']['output'];
};

export const PolymatcherExplainStatus = {
  BackendError: 'backendError',
  NotDeployed: 'notDeployed',
  NotRunning: 'notRunning',
  Ok: 'ok',
  Starting: 'starting',
  TimedOut: 'timedOut',
  Unauthorized: 'unauthorized',
  Unreachable: 'unreachable'
} as const;

export type PolymatcherExplainStatus = typeof PolymatcherExplainStatus[keyof typeof PolymatcherExplainStatus];
export const PolymatcherFiredState = {
  Fired: 'fired',
  NotFired: 'notFired',
  Unknown: 'unknown'
} as const;

export type PolymatcherFiredState = typeof PolymatcherFiredState[keyof typeof PolymatcherFiredState];
export type PolymatcherLabelAuthor = {
  __typename?: 'PolymatcherLabelAuthor';
  authorEmail: Scalars['String']['output'];
  authorSub: Scalars['ID']['output'];
};

export type PolymatcherLabelExport = {
  __typename?: 'PolymatcherLabelExport';
  at?: Maybe<Scalars['String']['output']>;
  authorEmail: Scalars['String']['output'];
  conditionId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['String']['output'];
  inferenceId?: Maybe<Scalars['ID']['output']>;
  marketText?: Maybe<Scalars['String']['output']>;
  newsText: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  pairKey: Scalars['String']['output'];
  postId?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  source: PolymatcherPairSource;
  tau?: Maybe<Scalars['Float']['output']>;
  unitDocText?: Maybe<Scalars['String']['output']>;
  unitId?: Maybe<Scalars['ID']['output']>;
  unitQuestion?: Maybe<Scalars['String']['output']>;
  value: PolymatcherLabelValue;
};

export type PolymatcherLabelExportInput = {
  batchSize: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
};

export type PolymatcherLabelExportPage = {
  __typename?: 'PolymatcherLabelExportPage';
  items: Array<PolymatcherLabelExport>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type PolymatcherLabelReviewInput = {
  batchSize: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  otherAuthorSub?: InputMaybe<Scalars['ID']['input']>;
};

export const PolymatcherLabelValue = {
  Match: 'match',
  NoMatch: 'noMatch',
  Unsure: 'unsure'
} as const;

export type PolymatcherLabelValue = typeof PolymatcherLabelValue[keyof typeof PolymatcherLabelValue];
export type PolymatcherLabellingCandidate = {
  __typename?: 'PolymatcherLabellingCandidate';
  at: Scalars['String']['output'];
  inferenceFired: PolymatcherFiredState;
  inferenceId: Scalars['ID']['output'];
  newsText: Scalars['String']['output'];
  pipelineFired: Scalars['Boolean']['output'];
  postId?: Maybe<Scalars['String']['output']>;
  rank: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
  tau?: Maybe<Scalars['Float']['output']>;
  unitDocText?: Maybe<Scalars['String']['output']>;
  unitId: Scalars['ID']['output'];
  unitQuestion?: Maybe<Scalars['String']['output']>;
};

export type PolymatcherLabellingCandidatePage = {
  __typename?: 'PolymatcherLabellingCandidatePage';
  items: Array<PolymatcherLabellingCandidate>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type PolymatcherLabellingQueueInput = {
  batchSize: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  inferenceFired?: InputMaybe<Scalars['Boolean']['input']>;
  pipelineFired?: InputMaybe<Scalars['Boolean']['input']>;
  sort: PolymatcherCandidateSort;
  /** @deprecated The source selects the query, not a field on this input */
  source?: InputMaybe<PolymatcherPairSource>;
  window?: InputMaybe<PolymatcherTimeWindowInput>;
};

export type PolymatcherManualPair = {
  __typename?: 'PolymatcherManualPair';
  ambiguousUnit: Scalars['Boolean']['output'];
  at: Scalars['String']['output'];
  conditionId: Scalars['ID']['output'];
  inferenceId?: Maybe<Scalars['ID']['output']>;
  marketQuestion: Scalars['String']['output'];
  newsText: Scalars['String']['output'];
  pipelineFired?: Maybe<Scalars['Boolean']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  tau?: Maybe<Scalars['Float']['output']>;
  unitDocText?: Maybe<Scalars['String']['output']>;
  unitId: Scalars['ID']['output'];
  unitQuestion?: Maybe<Scalars['String']['output']>;
};

export type PolymatcherManualPairInput = {
  at?: InputMaybe<Scalars['DateTime']['input']>;
  conditionId: Scalars['ID']['input'];
  inferenceId?: InputMaybe<Scalars['ID']['input']>;
  newsText?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['ID']['input']>;
};

export type PolymatcherMarket = {
  __typename?: 'PolymatcherMarket';
  conditionId: Scalars['ID']['output'];
  deactivatedAt?: Maybe<Scalars['String']['output']>;
  eventTitle?: Maybe<Scalars['String']['output']>;
  question: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  volume: Scalars['Float']['output'];
};

export type PolymatcherMarketSearchInput = {
  excludeTags?: InputMaybe<Array<Scalars['String']['input']>>;
  limit: Scalars['Int']['input'];
  recentlyClosed: Scalars['Boolean']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export const PolymatcherMissKind = {
  Ranking: 'ranking',
  Retrieval: 'retrieval'
} as const;

export type PolymatcherMissKind = typeof PolymatcherMissKind[keyof typeof PolymatcherMissKind];
export type PolymatcherModelStats = {
  __typename?: 'PolymatcherModelStats';
  dislikes: Scalars['Int']['output'];
  fired: Scalars['Int']['output'];
  inferences: Scalars['Int']['output'];
  likes: Scalars['Int']['output'];
  manualAdds: Scalars['Int']['output'];
  matchingModel?: Maybe<Scalars['String']['output']>;
  trades: Scalars['Int']['output'];
};

export type PolymatcherModelStatsDay = {
  __typename?: 'PolymatcherModelStatsDay';
  day: Scalars['String']['output'];
  models: Array<PolymatcherModelStats>;
};

export type PolymatcherNewsItem = {
  __typename?: 'PolymatcherNewsItem';
  at: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  source: PolymatcherNewsSource;
  text: Scalars['String']['output'];
};

export type PolymatcherNewsSearchInput = {
  limit: Scalars['Int']['input'];
  text: Scalars['String']['input'];
};

export const PolymatcherNewsSource = {
  Inference: 'inference',
  StreamPost: 'streamPost'
} as const;

export type PolymatcherNewsSource = typeof PolymatcherNewsSource[keyof typeof PolymatcherNewsSource];
export const PolymatcherPairSource = {
  Import: 'import',
  Inference: 'inference',
  Manual: 'manual',
  UserAction: 'userAction'
} as const;

export type PolymatcherPairSource = typeof PolymatcherPairSource[keyof typeof PolymatcherPairSource];
export type PolymatcherReviewLabel = {
  __typename?: 'PolymatcherReviewLabel';
  authorEmail: Scalars['String']['output'];
  authorSub: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  value: PolymatcherLabelValue;
};

export type PolymatcherReviewPair = {
  __typename?: 'PolymatcherReviewPair';
  at?: Maybe<Scalars['String']['output']>;
  conditionId?: Maybe<Scalars['ID']['output']>;
  inferenceId?: Maybe<Scalars['ID']['output']>;
  labels: Array<PolymatcherReviewLabel>;
  marketText?: Maybe<Scalars['String']['output']>;
  newsText: Scalars['String']['output'];
  pairId: Scalars['ID']['output'];
  postId?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  source: PolymatcherPairSource;
  tau?: Maybe<Scalars['Float']['output']>;
  unitDocText?: Maybe<Scalars['String']['output']>;
  unitId?: Maybe<Scalars['ID']['output']>;
  unitQuestion?: Maybe<Scalars['String']['output']>;
};

export type PolymatcherReviewPairPage = {
  __typename?: 'PolymatcherReviewPairPage';
  items: Array<PolymatcherReviewPair>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type PolymatcherSetLabelInput = {
  conditionId?: InputMaybe<Scalars['ID']['input']>;
  inferenceId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  rank: Scalars['Int']['input'];
  value: PolymatcherLabelValue;
};

export type PolymatcherSetLabelResult = {
  __typename?: 'PolymatcherSetLabelResult';
  labelId: Scalars['ID']['output'];
  pairId: Scalars['ID']['output'];
};

export type PolymatcherSetManualLabelInput = {
  at?: InputMaybe<Scalars['DateTime']['input']>;
  conditionId: Scalars['ID']['input'];
  inferenceId?: InputMaybe<Scalars['ID']['input']>;
  newsText?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['ID']['input']>;
  value: PolymatcherLabelValue;
};

export type PolymatcherSetUserActionLabelInput = {
  conditionId: Scalars['ID']['input'];
  /** @deprecated The pair is keyed on the source post */
  inferenceId?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  sourcePostId?: InputMaybe<Scalars['ID']['input']>;
  unitId: Scalars['ID']['input'];
  value: PolymatcherLabelValue;
};

export type PolymatcherTimeWindowInput = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type PolymatcherUnitMarket = {
  __typename?: 'PolymatcherUnitMarket';
  conditionId: Scalars['ID']['output'];
  question: Scalars['String']['output'];
};

export type PolymatcherUserActionCandidate = {
  __typename?: 'PolymatcherUserActionCandidate';
  at?: Maybe<Scalars['String']['output']>;
  conditionId: Scalars['ID']['output'];
  dislikes: Scalars['Int']['output'];
  inferenceId?: Maybe<Scalars['ID']['output']>;
  lastActionAt: Scalars['String']['output'];
  likes: Scalars['Int']['output'];
  manualAdds: Scalars['Int']['output'];
  marketText: Scalars['String']['output'];
  miss?: Maybe<PolymatcherMissKind>;
  newsText: Scalars['String']['output'];
  rank?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  sourcePostId: Scalars['ID']['output'];
  tau?: Maybe<Scalars['Float']['output']>;
  trades: Scalars['Int']['output'];
  unitDocText?: Maybe<Scalars['String']['output']>;
  unitId: Scalars['ID']['output'];
  unitQuestion?: Maybe<Scalars['String']['output']>;
};

export type PolymatcherUserActionCandidatePage = {
  __typename?: 'PolymatcherUserActionCandidatePage';
  items: Array<PolymatcherUserActionCandidate>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type PolymatcherUserActionQueueInput = {
  actionType?: InputMaybe<PolymatcherActionType>;
  batchSize: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  window?: InputMaybe<PolymatcherTimeWindowInput>;
};

export type PolymatcherUserActionRefreshReport = {
  __typename?: 'PolymatcherUserActionRefreshReport';
  ambiguousUnitInterval: Scalars['Int']['output'];
  kept: Scalars['Int']['output'];
  resolved: Scalars['Int']['output'];
  seen: Scalars['Int']['output'];
  unmappable: Scalars['Int']['output'];
  unresolved: Scalars['Int']['output'];
  unresolvedByCause: PolymatcherUserActionUnresolvedCauses;
  viaCatalog: Scalars['Int']['output'];
  written: Scalars['Int']['output'];
};

export type PolymatcherUserActionUnresolvedCauses = {
  __typename?: 'PolymatcherUserActionUnresolvedCauses';
  marketNotInCatalog: Scalars['Int']['output'];
  /** @deprecated A missing inference now resolves from the catalog */
  noInference: Scalars['Int']['output'];
  noPostText: Scalars['Int']['output'];
  noSourcePostId: Scalars['Int']['output'];
  postMissing: Scalars['Int']['output'];
  sourcePostMissing: Scalars['Int']['output'];
  unknownPostType: Scalars['Int']['output'];
};

export type PostMarketAddMarketSignal = {
  __typename?: 'PostMarketAddMarketSignal';
  createdAt: Scalars['String']['output'];
  marketId: Scalars['ID']['output'];
  platform: PostMarketSignalPlatform;
  postId: Scalars['ID']['output'];
  source: PostMarketSignalSource;
  sourcePostId?: Maybe<Scalars['ID']['output']>;
  streamId: Scalars['ID']['output'];
  trigger: PostMarketSignalTrigger;
  userId: Scalars['ID']['output'];
};

export type PostMarketAddMarketSignalInput = {
  marketId: Scalars['ID']['input'];
  platform: PostMarketSignalPlatform;
  postId: Scalars['ID']['input'];
  sourcePostId?: InputMaybe<Scalars['ID']['input']>;
  streamId: Scalars['ID']['input'];
  trigger: PostMarketSignalTrigger;
};

export type PostMarketButtonSignalInput = {
  action: PostMarketSignalAction;
  marketId: Scalars['ID']['input'];
  platform: PostMarketSignalPlatform;
  postId: Scalars['ID']['input'];
  sourcePostId?: InputMaybe<Scalars['ID']['input']>;
  streamId: Scalars['ID']['input'];
};

export type PostMarketSignal = {
  __typename?: 'PostMarketSignal';
  action: PostMarketSignalAction;
  createdAt: Scalars['String']['output'];
  marketId: Scalars['ID']['output'];
  platform: PostMarketSignalPlatform;
  postId: Scalars['ID']['output'];
  source: PostMarketSignalSource;
  sourcePostId?: Maybe<Scalars['ID']['output']>;
  streamId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export const PostMarketSignalAction = {
  Dislike: 'DISLIKE',
  Like: 'LIKE'
} as const;

export type PostMarketSignalAction = typeof PostMarketSignalAction[keyof typeof PostMarketSignalAction];
export const PostMarketSignalPlatform = {
  Binance: 'BINANCE',
  Bybit: 'BYBIT',
  Hyperliquid: 'HYPERLIQUID',
  Kalshi: 'KALSHI',
  Polymarket: 'POLYMARKET'
} as const;

export type PostMarketSignalPlatform = typeof PostMarketSignalPlatform[keyof typeof PostMarketSignalPlatform];
export const PostMarketSignalSource = {
  AddMarket: 'ADD_MARKET',
  Button: 'BUTTON',
  Trade: 'TRADE'
} as const;

export type PostMarketSignalSource = typeof PostMarketSignalSource[keyof typeof PostMarketSignalSource];
export const PostMarketSignalTrigger = {
  Group: 'GROUP',
  Post: 'POST'
} as const;

export type PostMarketSignalTrigger = typeof PostMarketSignalTrigger[keyof typeof PostMarketSignalTrigger];
export type PostMatchFilterInput = {
  crypto?: InputMaybe<Scalars['Boolean']['input']>;
  cryptoKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  kalshi?: InputMaybe<Scalars['Boolean']['input']>;
  kalshiTickers?: InputMaybe<Array<Scalars['String']['input']>>;
  polymarket?: InputMaybe<Scalars['Boolean']['input']>;
  polymarketMarketIds?: InputMaybe<Array<Scalars['String']['input']>>;
  widenWithHighlights?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProtectedStreamFields = {
  __typename?: 'ProtectedStreamFields';
  streamApiKeys: Array<StreamApiKey>;
};

export type ProtectedUserFields = {
  __typename?: 'ProtectedUserFields';
  apiKeys?: Maybe<Array<StreamApiKey>>;
  coupons?: Maybe<Array<UserCoupon>>;
  email: Scalars['String']['output'];
  intercomHmac: Scalars['String']['output'];
  isOnboardingFinished: Scalars['Boolean']['output'];
  onboardingProgress?: Maybe<Array<OnboardingType>>;
  possibleUsernames?: Maybe<Array<Scalars['String']['output']>>;
  pushNotificationSubscriptions?: Maybe<Array<PushNotificationSubscription>>;
  stripeExpressSellerAccount?: Maybe<StripeSellerAccount>;
  twttrApiAccount: TwttrApiAccount;
  voxSubscription: VoxSubscription;
};

export type PublicStreamPostPreviewInput = {
  excludedPostTypes?: InputMaybe<Array<StreamPostType>>;
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchFilter?: InputMaybe<PostMatchFilterInput>;
};

export type PushNotificationSubscription = {
  __typename?: 'PushNotificationSubscription';
  endpoint: Scalars['String']['output'];
  keys: KeysType;
};

export type PushNotificationSubscriptionInput = {
  endpoint: Scalars['String']['input'];
  expirationTime?: InputMaybe<Scalars['String']['input']>;
  keys?: InputMaybe<KeysInput>;
};

export type Query = {
  __typename?: 'Query';
  OpticFeedsTwttrQuery: OpticFeedsTwttrQuery;
  /** Full enrichment service registry (admin). */
  adminEnrichmentServices: Array<EnrichmentService>;
  aiFilterTest: Scalars['Boolean']['output'];
  aiFilters: Array<AiFilter>;
  allStreamsPostsSearch: StreamPostsPage;
  customCollectionPosts: CustomCollectionPostsPage;
  discussionFeed: DiscussionPage;
  enrichmentInvocations: EnrichmentInvocationPage;
  enrichmentLatencyBuckets: Array<EnrichmentLatencyBucket>;
  /** Enabled enrichment service names for the route editor picker. Does not expose urls or secrets. */
  enrichmentServices: Array<EnrichmentServiceName>;
  enterpriseStreamPosts: EnterpriseStreamPostsPage;
  exportEnterpriseStreamPostsUrl: Scalars['String']['output'];
  exportStreamPostsUrl: Scalars['String']['output'];
  flags: Array<Flag>;
  followersByName: UsersPage;
  followingByName: UsersPage;
  getCustomerBillingPortalSession: StripeBillingPortalSession;
  getStreamFollowExpiration?: Maybe<Scalars['String']['output']>;
  getUserStreamPackagesSubscribed: Array<StreamPackage>;
  getUserStreamsFollowed: Array<Stream>;
  getUserStreamsSubscribed: Array<Stream>;
  getUsers: UsersPage;
  highlightedAuthors: Array<User>;
  learningProgress: LearningProgress;
  me: User;
  mySourceTags: Array<Scalars['String']['output']>;
  mySources: SourceSearchResult;
  myTimeSeries: Array<TimeSeries>;
  myVoxFullAccessRequest?: Maybe<VoxFullAccessRequest>;
  notifications: NotificationsPage;
  organization?: Maybe<OrganizationObject>;
  organizationUsers: UsersPage;
  organizations: OrganizationsPage;
  polymatcherCandidates: PolymatcherCandidatePage;
  polymatcherLabelAuthors: Array<PolymatcherLabelAuthor>;
  polymatcherLabelExport: PolymatcherLabelExportPage;
  polymatcherLabelReview: PolymatcherReviewPairPage;
  polymatcherLabellingQueue: PolymatcherLabellingCandidatePage;
  polymatcherManualPair?: Maybe<PolymatcherManualPair>;
  polymatcherMarketSearch: Array<PolymatcherMarket>;
  polymatcherModelStats: Array<PolymatcherModelStats>;
  polymatcherModelStatsByDay: Array<PolymatcherModelStatsDay>;
  polymatcherNewsSearch: Array<PolymatcherNewsItem>;
  polymatcherUnitMarkets: Array<PolymatcherUnitMarket>;
  polymatcherUserActionQueue: PolymatcherUserActionCandidatePage;
  post?: Maybe<StreamPost>;
  publicStreamPostPreview: StreamPostsPage;
  search: SearchResultPage;
  searchStreamPosts: StreamPostsPage;
  settings: UserSettings;
  source?: Maybe<Source>;
  sourcePostSearch: SourcePostSearchResult;
  stream?: Maybe<Stream>;
  streamDecks: Array<StreamDeck>;
  /** Whether any time series chart is shown on this stream. */
  streamHasTimeSeries: Scalars['Boolean']['output'];
  streamInvites: StreamInvitesPage;
  streamPackage?: Maybe<StreamPackage>;
  streamPackages: StreamPackagesPage;
  streamPosts: StreamPostsPage;
  streamPostsStats: StreamPostsStatsResult;
  streamRoutes: Array<SourceRoute>;
  streamTimeSeries: Array<TimeSeries>;
  streamUsers: Array<User>;
  streamsAll: StreamsPage;
  streamsCreated: StreamsPage;
  streamsFollowing: StreamsPage;
  streamsStats: StreamsStatsResult;
  summarizeStreamPost: Scalars['String']['output'];
  terminalSettings: TerminalSettings;
  terminalTabs: Array<TerminalTab>;
  terminalVolumeLeaderboard: TerminalVolumeLeaderboardPage;
  terminalVolumeViewerEntry?: Maybe<TerminalVolumeViewerEntry>;
  /** The label keys of a series and the values each one takes. */
  timeSeriesLabels: Array<TimeSeriesLabelValues>;
  /** The newest point of every dimension matching the label filter. */
  timeSeriesLatest: Array<TimeSeriesLatestPoint>;
  /** Bars per dimension of a series, for the dimensions matching the label filter. */
  timeSeriesLines: TimeSeriesLines;
  translateFastInferences: TranslateFastInferencePage;
  translateFastLatencyBuckets: Array<TranslateFastLatencyBucket>;
  typeahead: TypeaheadResult;
  user: User;
  userStreamInvites: StreamInvitesPage;
  userStreams: StreamsPage;
  voxConfig: VoxConfig;
  voxFullAccessRequests: VoxFullAccessRequestsPage;
  voxHistory: VoxHistoryPage;
  voxTextSearch: VoxTextSearchResult;
  voxUserNamesSearch: VoxUserNamesSearchResult;
  voxUserSearch: VoxUserProfileResult;
};


export type QueryAiFilterTestArgs = {
  filter: AiFilterTestInput;
  text: Scalars['String']['input'];
};


export type QueryAllStreamsPostsSearchArgs = {
  input: AllStreamsPostsSearchInput;
};


export type QueryCustomCollectionPostsArgs = {
  input: CustomCollectionPostsInput;
};


export type QueryDiscussionFeedArgs = {
  input: DiscussionFeedInput;
};


export type QueryEnrichmentInvocationsArgs = {
  input: EnrichmentInvocationsInput;
};


export type QueryEnrichmentLatencyBucketsArgs = {
  input: EnrichmentLatencyBucketsInput;
};


export type QueryEnterpriseStreamPostsArgs = {
  input: EnterpriseStreamPostsInput;
};


export type QueryExportEnterpriseStreamPostsUrlArgs = {
  input: ExportEnterpriseStreamPostsInput;
};


export type QueryExportStreamPostsUrlArgs = {
  input: ExportStreamPostsInput;
};


export type QueryFollowersByNameArgs = {
  input: UsersByNameInput;
};


export type QueryFollowingByNameArgs = {
  input: UsersByNameInput;
};


export type QueryGetStreamFollowExpirationArgs = {
  input: StreamFollowExpirationInput;
};


export type QueryGetUserStreamPackagesSubscribedArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUserStreamsFollowedArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUserStreamsSubscribedArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUsersArgs = {
  input: UsersListInput;
};


export type QueryMySourcesArgs = {
  input: MySourcesInput;
};


export type QueryNotificationsArgs = {
  input: NotificationsInput;
};


export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationUsersArgs = {
  input: OrganizationUsersInput;
};


export type QueryOrganizationsArgs = {
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPolymatcherCandidatesArgs = {
  input: PolymatcherCandidateSearchInput;
};


export type QueryPolymatcherLabelExportArgs = {
  input: PolymatcherLabelExportInput;
};


export type QueryPolymatcherLabelReviewArgs = {
  input: PolymatcherLabelReviewInput;
};


export type QueryPolymatcherLabellingQueueArgs = {
  input: PolymatcherLabellingQueueInput;
};


export type QueryPolymatcherManualPairArgs = {
  input: PolymatcherManualPairInput;
};


export type QueryPolymatcherMarketSearchArgs = {
  input: PolymatcherMarketSearchInput;
};


export type QueryPolymatcherModelStatsArgs = {
  input: PolymatcherTimeWindowInput;
};


export type QueryPolymatcherModelStatsByDayArgs = {
  input: PolymatcherTimeWindowInput;
};


export type QueryPolymatcherNewsSearchArgs = {
  input: PolymatcherNewsSearchInput;
};


export type QueryPolymatcherUnitMarketsArgs = {
  unitId: Scalars['ID']['input'];
};


export type QueryPolymatcherUserActionQueueArgs = {
  input: PolymatcherUserActionQueueInput;
};


export type QueryPostArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublicStreamPostPreviewArgs = {
  input: PublicStreamPostPreviewInput;
};


export type QuerySearchArgs = {
  input: SearchInput;
};


export type QuerySearchStreamPostsArgs = {
  input: SearchStreamPostsInput;
};


export type QuerySourceArgs = {
  sourceId: Scalars['ID']['input'];
};


export type QuerySourcePostSearchArgs = {
  input: SourcePostSearchInput;
};


export type QueryStreamArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStreamHasTimeSeriesArgs = {
  streamId: Scalars['ID']['input'];
};


export type QueryStreamInvitesArgs = {
  input: StreamInvitesInput;
};


export type QueryStreamPackageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStreamPackagesArgs = {
  input: StreamPackagesInput;
};


export type QueryStreamPostsArgs = {
  input: StreamPostsInput;
};


export type QueryStreamPostsStatsArgs = {
  input: StreamPostsStatsInput;
};


export type QueryStreamRoutesArgs = {
  streamId: Scalars['ID']['input'];
};


export type QueryStreamTimeSeriesArgs = {
  streamId: Scalars['ID']['input'];
};


export type QueryStreamUsersArgs = {
  streamId: Scalars['ID']['input'];
  type: StreamUserFilterType;
};


export type QueryStreamsAllArgs = {
  input: StreamsAllInput;
};


export type QueryStreamsCreatedArgs = {
  input: StreamsPageInput;
};


export type QueryStreamsFollowingArgs = {
  input: StreamsPageInput;
};


export type QueryStreamsStatsArgs = {
  input: StreamsStatsInput;
};


export type QuerySummarizeStreamPostArgs = {
  postId: Scalars['ID']['input'];
};


export type QueryTerminalVolumeLeaderboardArgs = {
  input: TerminalVolumeLeaderboardInput;
};


export type QueryTerminalVolumeViewerEntryArgs = {
  exchange?: InputMaybe<TerminalVolumeExchange>;
  period?: TerminalVolumePeriod;
};


export type QueryTimeSeriesLabelsArgs = {
  seriesId: Scalars['UUID']['input'];
  streamId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTimeSeriesLatestArgs = {
  input: TimeSeriesReadInput;
};


export type QueryTimeSeriesLinesArgs = {
  input: TimeSeriesLinesInput;
};


export type QueryTranslateFastInferencesArgs = {
  input: TranslateFastInferencesInput;
};


export type QueryTranslateFastLatencyBucketsArgs = {
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};


export type QueryTypeaheadArgs = {
  input: TypeaheadInput;
};


export type QueryUserArgs = {
  username: Scalars['String']['input'];
};


export type QueryUserStreamInvitesArgs = {
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserStreamsArgs = {
  input: UserStreamsInput;
};


export type QueryVoxFullAccessRequestsArgs = {
  input: VoxFullAccessRequestsInput;
};


export type QueryVoxHistoryArgs = {
  input: VoxHistoryInput;
};


export type QueryVoxTextSearchArgs = {
  input: VoxTextSearchInput;
};


export type QueryVoxUserNamesSearchArgs = {
  input: VoxUserSearchInput;
};


export type QueryVoxUserSearchArgs = {
  input: VoxUserSearchInput;
};

export type RedeemPointsResult = {
  __typename?: 'RedeemPointsResult';
  redeemedPoints: Scalars['Int']['output'];
  remainingPoints: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type S3Object = {
  __typename?: 'S3Object';
  bucket: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  /** Indicates if the S3 upload is pending */
  isS3UploadPending?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  region: Scalars['String']['output'];
  /** file mime type */
  type: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type S3ObjectInput = {
  bucket: Scalars['String']['input'];
  height?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates if the S3 upload is pending */
  isS3UploadPending?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  region: Scalars['String']['input'];
  /** file mime type */
  type: Scalars['String']['input'];
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type SchemaHistoryEntry = {
  __typename?: 'SchemaHistoryEntry';
  schema: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type SearchFilters = {
  stream?: InputMaybe<StreamSearchFilters>;
  type?: InputMaybe<Array<SearchType>>;
};

export type SearchInput = {
  filters?: InputMaybe<SearchFilters>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  text: Scalars['String']['input'];
  type?: InputMaybe<Array<SearchType>>;
};

export type SearchResultPage = IOffsetPage & {
  __typename?: 'SearchResultPage';
  items: Array<Node>;
  offset?: Maybe<Scalars['Int']['output']>;
};

export type SearchStreamPostsInput = {
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  streamId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export const SearchType = {
  Stream: 'Stream',
  StreamPackage: 'StreamPackage',
  User: 'User'
} as const;

export type SearchType = typeof SearchType[keyof typeof SearchType];
export type SetCustomCollectionColumnWidthInput = {
  collectionId: Scalars['ID']['input'];
  streamDeckId: Scalars['ID']['input'];
  width: Scalars['Int']['input'];
};

export type SetStreamCustomTargetsInput = {
  customTargets: Array<Scalars['String']['input']>;
};

export type SetStreamFollowExpirationInput = {
  expiresAt: Scalars['String']['input'];
  streamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type SetTerminalVolumeLeaderboardEntryInput = {
  exchange?: InputMaybe<TerminalVolumeExchange>;
  exchanges?: InputMaybe<Array<TerminalVolumeExchange>>;
  fillCount: Scalars['Int']['input'];
  period: TerminalVolumePeriod;
  userId: Scalars['ID']['input'];
  volumeUsd: Scalars['Float']['input'];
};

export type Source = {
  __typename?: 'Source';
  name: Scalars['String']['output'];
  /** Private admin notes, for example what the source really is. Never exposed outside admin Source APIs. */
  notes?: Maybe<Scalars['String']['output']>;
  routes: Array<SourceRoute>;
  schema: Scalars['String']['output'];
  schemaHistory?: Maybe<Array<SchemaHistoryEntry>>;
  schemaVersion: Scalars['Int']['output'];
  sourceId: Scalars['ID']['output'];
  tags: Array<Scalars['String']['output']>;
};

export type SourcePost = {
  __typename?: 'SourcePost';
  createdAt: Scalars['String']['output'];
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  schemaVersion: Scalars['Int']['output'];
  sourceId: Scalars['String']['output'];
  validationErrors?: Maybe<Array<Scalars['String']['output']>>;
  validationStatus: ValidationStatus;
};

export type SourcePostSearchInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sourceId: Scalars['ID']['input'];
  status?: InputMaybe<ValidationStatus>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type SourcePostSearchResult = {
  __typename?: 'SourcePostSearchResult';
  items: Array<SourcePost>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export type SourceRoute = {
  __typename?: 'SourceRoute';
  createdAt: Scalars['String']['output'];
  delayMs?: Maybe<Scalars['Int']['output']>;
  /** Discord webhook id/token for this route. Posts are POSTed to https://discord.com/api/webhooks/{value}. */
  discordWebhook?: Maybe<Scalars['String']['output']>;
  /** Enricher bindings applied on this route before fan-out. */
  enrichments?: Maybe<Array<SourceRouteEnrichment>>;
  /** Whether posts on this route are published to the enterprise API. */
  enterprise: Scalars['Boolean']['output'];
  /** Paused routes persist source posts but forward nothing (WS, stream posts, enterprise). New routes start paused. */
  paused: Scalars['Boolean']['output'];
  routeId: Scalars['ID']['output'];
  source?: Maybe<Source>;
  sourceId: Scalars['ID']['output'];
  stream?: Maybe<Stream>;
  streamId: Scalars['ID']['output'];
  /** Markdown template applied to posts forwarded to the ws-api on this route. */
  wsMarkdownTemplate?: Maybe<Scalars['String']['output']>;
  /** JSON template for the post metadata and vendorMetadata forwarded to the ws-api on this route. */
  wsMetadataTemplate?: Maybe<Scalars['String']['output']>;
};

export type SourceRouteEnrichment = {
  __typename?: 'SourceRouteEnrichment';
  /** JSON value used when the enricher fails. String leaves are template-rendered against source data plus {{input}}. */
  errorFallback?: Maybe<Scalars['String']['output']>;
  inputTemplate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type SourceRouteEnrichmentInput = {
  /** JSON value used when the enricher fails. String leaves are template-rendered against source data plus {{input}}. */
  errorFallback?: InputMaybe<Scalars['String']['input']>;
  inputTemplate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type SourceSearchResult = {
  __typename?: 'SourceSearchResult';
  items: Array<Source>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export const StatsInterval = {
  Day: 'DAY',
  Hour: 'HOUR',
  Minute: 'MINUTE',
  Month: 'MONTH',
  Week: 'WEEK'
} as const;

export type StatsInterval = typeof StatsInterval[keyof typeof StatsInterval];
export type Stream = Node & {
  __typename?: 'Stream';
  accessAllowed: Scalars['Boolean']['output'];
  apiAccessEnabled: Scalars['Boolean']['output'];
  author: User;
  canAddToStreamDeck: Scalars['Boolean']['output'];
  customTargets?: Maybe<Array<Scalars['String']['output']>>;
  customTargetsData?: Maybe<CustomTargetsData>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionJson: Scalars['LexicalJSON']['output'];
  followersCount: Scalars['Int']['output'];
  following: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  inPackages: Array<StreamPackage>;
  isEmpty: Scalars['Boolean']['output'];
  isFeatured: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  packageOnly: Scalars['Boolean']['output'];
  paidData?: Maybe<Array<StripePrice>>;
  /** True when at least one source route into this stream binds the polymatcher enricher. */
  polymatcherEnabled: Scalars['Boolean']['output'];
  protectedFields?: Maybe<ProtectedStreamFields>;
  slug: Scalars['String']['output'];
  /** Ingest sources routed into this stream, deduplicated. Empty when the caller cannot add the stream to a list. */
  sources: Array<StreamSource>;
  streamCategory: StreamCategory;
  streamState: StreamState;
  streamType: StreamType;
  subscription?: Maybe<StreamSubscription>;
};

export type StreamApiKey = Node & {
  __typename?: 'StreamApiKey';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  keyName?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<ApiKeyPermissionsObject>;
  secretHint: Scalars['String']['output'];
};

export const StreamCategory = {
  Markets: 'MARKETS',
  News: 'NEWS',
  OnChain: 'ON_CHAIN',
  Osint: 'OSINT',
  Other: 'OTHER',
  Regulatory: 'REGULATORY'
} as const;

export type StreamCategory = typeof StreamCategory[keyof typeof StreamCategory];
export type StreamDeck = Node & {
  __typename?: 'StreamDeck';
  collections: Array<CustomCollection>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type StreamFollowExpirationInput = {
  streamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type StreamInput = {
  apiAccessEnabled: Scalars['Boolean']['input'];
  customTargetsData?: InputMaybe<CustomTargetsDataInput>;
  /** @deprecated use descriptionJson instead */
  description?: InputMaybe<Scalars['LexicalJSON']['input']>;
  descriptionJson?: InputMaybe<Scalars['LexicalJSON']['input']>;
  image?: InputMaybe<S3ObjectInput>;
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
  packageOnly?: Scalars['Boolean']['input'];
  paidData?: InputMaybe<PaidDataInput>;
  streamCategory?: StreamCategory;
  streamType?: StreamType;
};

export type StreamInvite = Node & {
  __typename?: 'StreamInvite';
  createdAt: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invitee?: Maybe<User>;
  stream: Stream;
  streamInviteId: Scalars['ID']['output'];
};

export type StreamInvitesInput = {
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
  streamId: Scalars['ID']['input'];
};

export type StreamInvitesPage = {
  __typename?: 'StreamInvitesPage';
  items: Array<StreamInvite>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export const StreamKind = {
  Custom: 'CUSTOM',
  Data: 'DATA'
} as const;

export type StreamKind = typeof StreamKind[keyof typeof StreamKind];
export type StreamListFilters = {
  __typename?: 'StreamListFilters';
  /** Max matched markets to show per post (1-10) */
  maxMatchedMarkets: Scalars['Int']['output'];
  /** Hide markets missing a 0.1¢ orderbook level on either outcome side */
  requireOrderbookTails: Scalars['Boolean']['output'];
  /** Maximum market volume for stream list matched markets */
  volumeMax?: Maybe<Scalars['Float']['output']>;
  /** Minimum market volume for stream list matched markets */
  volumeMin?: Maybe<Scalars['Float']['output']>;
};

export type StreamListFiltersInput = {
  maxMatchedMarkets?: InputMaybe<Scalars['Int']['input']>;
  requireOrderbookTails?: InputMaybe<Scalars['Boolean']['input']>;
  volumeMax?: InputMaybe<Scalars['Float']['input']>;
  volumeMin?: InputMaybe<Scalars['Float']['input']>;
};

export type StreamPackage = Node & {
  __typename?: 'StreamPackage';
  author: User;
  description?: Maybe<Scalars['String']['output']>;
  descriptionJson: Scalars['LexicalJSON']['output'];
  id: Scalars['ID']['output'];
  includedStreams: Array<Stream>;
  isFeaturedPackage: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  paidData: Array<StripePrice>;
  streamPackageCategory: StreamCategory;
  subscribersCount: Scalars['Int']['output'];
  subscription?: Maybe<StreamPackageSubscription>;
};

export const StreamPackageBadge = {
  ExclusiveContent: 'EXCLUSIVE_CONTENT',
  SaveValue: 'SAVE_VALUE'
} as const;

export type StreamPackageBadge = typeof StreamPackageBadge[keyof typeof StreamPackageBadge];
export type StreamPackageInput = {
  badge: StreamPackageBadge;
  /** @deprecated use descriptionJson instead */
  description?: InputMaybe<Scalars['LexicalJSON']['input']>;
  descriptionJson?: InputMaybe<Scalars['LexicalJSON']['input']>;
  image?: InputMaybe<S3ObjectInput>;
  includedStreamIds: Array<Scalars['ID']['input']>;
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
  paidData: PaidDataInput;
  streamPackageCategory: StreamCategory;
};

export const StreamPackageQueryType = {
  All: 'ALL',
  Created: 'CREATED',
  Featured: 'FEATURED',
  Subscribed: 'SUBSCRIBED'
} as const;

export type StreamPackageQueryType = typeof StreamPackageQueryType[keyof typeof StreamPackageQueryType];
export type StreamPackageSubscription = {
  __typename?: 'StreamPackageSubscription';
  active: Scalars['Boolean']['output'];
  cancelAt?: Maybe<Scalars['String']['output']>;
  interval: StripeBillingInterval;
  intervalCount: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
};

export type StreamPackageSubscriptionCancelInput = {
  cancelationComment: Scalars['String']['input'];
  cancelationReason: StreamSubscriptionCancelReason;
  refundComment?: InputMaybe<Scalars['String']['input']>;
  streamPackageId: Scalars['ID']['input'];
};

export type StreamPackageSubscriptionCheckoutInput = {
  priceId: Scalars['String']['input'];
  redeemPoints?: InputMaybe<Scalars['Int']['input']>;
  streamPackageId: Scalars['ID']['input'];
};

export type StreamPackagesInput = {
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
  queryType?: StreamPackageQueryType;
  streamPackageCategory?: InputMaybe<StreamCategory>;
};

export type StreamPackagesPage = {
  __typename?: 'StreamPackagesPage';
  items: Array<StreamPackage>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type StreamPost = IPost & Node & {
  __typename?: 'StreamPost';
  author: User;
  authorId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  customTarget?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  /** Structured enrichments attached by source-route enrichers. Omitted when empty. */
  enrichments?: Maybe<EnrichmentsObject>;
  id: Scalars['ID']['output'];
  matchAiFilter?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<Array<S3Object>>;
  metadata?: Maybe<MetadataObject>;
  /** Source that produced this post via a source route. */
  sourceId?: Maybe<Scalars['ID']['output']>;
  /** Source post id used by enrichers. Distinct from this stream post id because one source post can fan out to multiple streams. */
  sourcePostId?: Maybe<Scalars['ID']['output']>;
  stream: Stream;
  summary?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  vendorMetadata?: Maybe<Scalars['JSON']['output']>;
};

export type StreamPostCount = {
  __typename?: 'StreamPostCount';
  count: Scalars['Int']['output'];
  streamId: Scalars['ID']['output'];
};

export type StreamPostInput = {
  customTarget?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<S3ObjectInput>>;
  metadata?: InputMaybe<MetadataInput>;
  streamId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

/** Kind of post a list can exclude from a stream, matched against StreamPost.metadata.type. */
export const StreamPostType = {
  Quote: 'QUOTE',
  Reply: 'REPLY',
  Retweet: 'RETWEET'
} as const;

export type StreamPostType = typeof StreamPostType[keyof typeof StreamPostType];
export type StreamPostsInput = {
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  limit?: Scalars['Int']['input'];
  matchFilter?: InputMaybe<PostMatchFilterInput>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StreamPostsPage = {
  __typename?: 'StreamPostsPage';
  items: Array<StreamPost>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type StreamPostsStatsInput = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  interval: StatsInterval;
  streamId: Scalars['ID']['input'];
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type StreamPostsStatsResult = {
  __typename?: 'StreamPostsStatsResult';
  buckets: Array<TimeBucket>;
  total: Scalars['Int']['output'];
};

export const StreamPricingType = {
  All: 'ALL',
  Free: 'FREE',
  PackageOnly: 'PACKAGE_ONLY',
  Paid: 'PAID'
} as const;

export type StreamPricingType = typeof StreamPricingType[keyof typeof StreamPricingType];
export const StreamQueryType = {
  All: 'ALL',
  Created: 'CREATED',
  Following: 'FOLLOWING'
} as const;

export type StreamQueryType = typeof StreamQueryType[keyof typeof StreamQueryType];
export type StreamSearchFilters = {
  createdByMe?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use kind instead. */
  custom?: InputMaybe<Scalars['Boolean']['input']>;
  following?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<StreamKind>;
  /** When set, only streams with this polymatcherEnabled value are returned. Other result types are unchanged. Omitted applies no filter. A missing value counts as false. */
  polymatcherEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pricingType?: InputMaybe<StreamPricingType>;
  sortBy?: InputMaybe<StreamSortBy>;
  streamCategory?: InputMaybe<StreamCategory>;
  streamState?: InputMaybe<StreamState>;
  streamType?: InputMaybe<StreamType>;
};

export const StreamSortBy = {
  CreatedAt: 'CREATED_AT',
  Featured: 'FEATURED',
  Followers: 'FOLLOWERS'
} as const;

export type StreamSortBy = typeof StreamSortBy[keyof typeof StreamSortBy];
/** Ingest source routed into a stream via a source route. */
export type StreamSource = {
  __typename?: 'StreamSource';
  name: Scalars['String']['output'];
  sourceId: Scalars['ID']['output'];
};

export const StreamState = {
  Active: 'ACTIVE',
  Deleted: 'DELETED',
  Draft: 'DRAFT',
  Inactive: 'INACTIVE',
  OnHold: 'ON_HOLD'
} as const;

export type StreamState = typeof StreamState[keyof typeof StreamState];
export type StreamSubscription = {
  __typename?: 'StreamSubscription';
  active: Scalars['Boolean']['output'];
  cancelAt?: Maybe<Scalars['String']['output']>;
  customTargets?: Maybe<Scalars['Int']['output']>;
  interval: StripeBillingInterval;
  intervalCount: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  signupTrial: Scalars['Boolean']['output'];
};

export type StreamSubscriptionCancelInput = {
  cancelationComment: Scalars['String']['input'];
  cancelationReason: StreamSubscriptionCancelReason;
  refundComment?: InputMaybe<Scalars['String']['input']>;
  streamId: Scalars['ID']['input'];
};

export const StreamSubscriptionCancelReason = {
  DissatisfiedWithQuality: 'DISSATISFIED_WITH_QUALITY',
  FoundBetterAlternative: 'FOUND_BETTER_ALTERNATIVE',
  NoNeedAnymore: 'NO_NEED_ANYMORE',
  Other: 'OTHER',
  RemovedByAuthor: 'REMOVED_BY_AUTHOR',
  TooExpensive: 'TOO_EXPENSIVE'
} as const;

export type StreamSubscriptionCancelReason = typeof StreamSubscriptionCancelReason[keyof typeof StreamSubscriptionCancelReason];
export type StreamSubscriptionCheckoutInput = {
  couponId?: InputMaybe<Scalars['String']['input']>;
  customTargetsCheckoutData?: InputMaybe<CustomTargetsCheckoutData>;
  priceId: Scalars['String']['input'];
  redeemPoints?: InputMaybe<Scalars['Int']['input']>;
  streamId: Scalars['ID']['input'];
};

export const StreamType = {
  Private: 'PRIVATE',
  Public: 'PUBLIC'
} as const;

export type StreamType = typeof StreamType[keyof typeof StreamType];
export const StreamUserFilterType = {
  Followers: 'FOLLOWERS',
  Subscribers: 'SUBSCRIBERS'
} as const;

export type StreamUserFilterType = typeof StreamUserFilterType[keyof typeof StreamUserFilterType];
export type StreamsAllInput = {
  custom?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<StreamKind>;
  limit?: Scalars['Int']['input'];
  minFollowers?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  pricingType?: InputMaybe<StreamPricingType>;
  sortBy?: InputMaybe<StreamSortBy>;
  streamCategory?: InputMaybe<StreamCategory>;
  streamState?: InputMaybe<StreamState>;
  streamType?: InputMaybe<StreamType>;
};

export type StreamsPage = {
  __typename?: 'StreamsPage';
  items: Array<Stream>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type StreamsPageInput = {
  kind?: InputMaybe<StreamKind>;
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
  pricingType?: InputMaybe<StreamPricingType>;
  sortBy?: InputMaybe<StreamSortBy>;
  streamCategory?: InputMaybe<StreamCategory>;
  streamState?: InputMaybe<StreamState>;
  streamType?: InputMaybe<StreamType>;
};

export type StreamsStatsInput = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  interval: StatsInterval;
  toDate?: InputMaybe<Scalars['String']['input']>;
  topN?: InputMaybe<Scalars['Int']['input']>;
};

export type StreamsStatsResult = {
  __typename?: 'StreamsStatsResult';
  buckets: Array<TimeBucket>;
  topStreams: Array<StreamPostCount>;
  total: Scalars['Int']['output'];
};

export const StripeBillingInterval = {
  Month: 'MONTH',
  Year: 'YEAR'
} as const;

export type StripeBillingInterval = typeof StripeBillingInterval[keyof typeof StripeBillingInterval];
export type StripeBillingPortalSession = {
  __typename?: 'StripeBillingPortalSession';
  url: Scalars['String']['output'];
};

export type StripePrice = {
  __typename?: 'StripePrice';
  amount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  interval: StripeBillingInterval;
  intervalCount: Scalars['Int']['output'];
};

export type StripePriceInput = {
  annualPrice: Scalars['Int']['input'];
  monthlyPrice: Scalars['Int']['input'];
  quarterlyPrice: Scalars['Int']['input'];
  semiAnnualPrice: Scalars['Int']['input'];
};

export const StripePriceType = {
  OneTime: 'ONE_TIME',
  Recurring: 'RECURRING'
} as const;

export type StripePriceType = typeof StripePriceType[keyof typeof StripePriceType];
export type StripeProduct = {
  __typename?: 'StripeProduct';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type StripeSellerAccount = {
  __typename?: 'StripeSellerAccount';
  id: Scalars['String']['output'];
  onboardingUrl: Scalars['String']['output'];
  props: StripeSellerAccountProps;
};


export type StripeSellerAccountOnboardingUrlArgs = {
  page?: OnboardingLinkPage;
  queryParams?: InputMaybe<Scalars['String']['input']>;
};

export type StripeSellerAccountProps = {
  __typename?: 'StripeSellerAccountProps';
  chargesEnabled: Scalars['Boolean']['output'];
  detailsSubmitted: Scalars['Boolean']['output'];
  documentsRequired: Scalars['Boolean']['output'];
  payoutsEnabled: Scalars['Boolean']['output'];
};

export type SubmitVoxFullAccessRequestInput = {
  confirmMonitoringAudit: Scalars['Boolean']['input'];
  confirmNoMisuse: Scalars['Boolean']['input'];
  investigationDetails: Scalars['String']['input'];
  legitimateNeed: Scalars['String']['input'];
  purpose: Scalars['String']['input'];
  useCase: Scalars['String']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  onCustomCollectionPostUpdate?: Maybe<CustomCollectionPostUpdate>;
  onCustomCollectionsChanged: Scalars['Boolean']['output'];
  onNotification?: Maybe<Notification>;
  publicStreamPostPreviewUpdates: StreamPost;
  streamPostsUpdates: StreamPost;
};


export type SubscriptionOnCustomCollectionPostUpdateArgs = {
  collectionId: Scalars['ID']['input'];
  streamDeckId: Scalars['ID']['input'];
};


export type SubscriptionPublicStreamPostPreviewUpdatesArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionStreamPostsUpdatesArgs = {
  streamId: Scalars['ID']['input'];
};

export type SubscriptionCheckout = {
  __typename?: 'SubscriptionCheckout';
  url: Scalars['String']['output'];
};

export type TerminalSettings = {
  __typename?: 'TerminalSettings';
  /** Enable double click on orderbook to place trade */
  enableOrderbookDoubleClick: Scalars['Boolean']['output'];
  /** Markets, events and tags excluded from post matching */
  marketBlacklist: Array<MarketBlacklistEntry>;
  /** Tags that keep their markets in post matching */
  marketGreenlist: Array<MarketBlacklistEntry>;
  marketGreenlistMode: MarketGreenlistMode;
  /** Max slippage in percent for crypto trades */
  maxSlippage?: Maybe<Scalars['Float']['output']>;
  /** When the user finished or skipped the first-run onboarding flow. Null means onboarding has not been completed yet. */
  onboardingCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Global filters for markets shown on stream/news lists */
  streamListFilters: StreamListFilters;
};

export type TerminalTab = Node & {
  __typename?: 'TerminalTab';
  configuration?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export const TerminalVolumeExchange = {
  All: 'ALL',
  Binance: 'BINANCE',
  Bybit: 'BYBIT',
  Hyperliquid: 'HYPERLIQUID',
  Kalshi: 'KALSHI',
  Polymarket: 'POLYMARKET'
} as const;

export type TerminalVolumeExchange = typeof TerminalVolumeExchange[keyof typeof TerminalVolumeExchange];
export type TerminalVolumeLeaderboardEntry = {
  __typename?: 'TerminalVolumeLeaderboardEntry';
  fillCount: Scalars['Int']['output'];
  user: User;
  volumeUsd: Scalars['Float']['output'];
};

export type TerminalVolumeLeaderboardInput = {
  exchange?: InputMaybe<TerminalVolumeExchange>;
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
  period?: TerminalVolumePeriod;
};

export type TerminalVolumeLeaderboardPage = {
  __typename?: 'TerminalVolumeLeaderboardPage';
  items: Array<TerminalVolumeLeaderboardEntry>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export const TerminalVolumePeriod = {
  AllTime: 'ALL_TIME',
  Month: 'MONTH',
  Week: 'WEEK'
} as const;

export type TerminalVolumePeriod = typeof TerminalVolumePeriod[keyof typeof TerminalVolumePeriod];
export type TerminalVolumeViewerEntry = {
  __typename?: 'TerminalVolumeViewerEntry';
  fillCount: Scalars['Int']['output'];
  /** The viewer opted out of the board; their volume still counts. */
  hidden: Scalars['Boolean']['output'];
  /** The viewer has not traded on this board and holds the place below it. */
  provisional: Scalars['Boolean']['output'];
  /** Null while the viewer is hidden from the board. */
  rank?: Maybe<Scalars['Int']['output']>;
  user: User;
  volumeUsd: Scalars['Float']['output'];
};

export type TimeBucket = {
  __typename?: 'TimeBucket';
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
};

export type TimeSeries = {
  __typename?: 'TimeSeries';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Whether the current user owns this series. */
  isOwner: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Streams showing this series. Visible to the owner only. */
  routes: Array<TimeSeriesRoute>;
  /** Display unit for values, e.g. "USD" or "%". */
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** One interval of a series. Intervals without points repeat the previous close. */
export type TimeSeriesBar = {
  __typename?: 'TimeSeriesBar';
  close: Scalars['Float']['output'];
  high: Scalars['Float']['output'];
  low: Scalars['Float']['output'];
  open: Scalars['Float']['output'];
  /** Interval start, unix seconds. */
  time: Scalars['Float']['output'];
};

export type TimeSeriesLabel = {
  __typename?: 'TimeSeriesLabel';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Keeps dimensions whose label `key` is one of `values`. Filters on different keys must all match. */
export type TimeSeriesLabelFilterInput = {
  key: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

/** Every value a label takes across a series. */
export type TimeSeriesLabelValues = {
  __typename?: 'TimeSeriesLabelValues';
  key: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

/** The newest point of one dimension. */
export type TimeSeriesLatestPoint = {
  __typename?: 'TimeSeriesLatestPoint';
  labels: Array<TimeSeriesLabel>;
  time: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

/** The bars of one dimension (label set) of a series. */
export type TimeSeriesLine = {
  __typename?: 'TimeSeriesLine';
  bars: Array<TimeSeriesBar>;
  labels: Array<TimeSeriesLabel>;
};

export type TimeSeriesLines = {
  __typename?: 'TimeSeriesLines';
  lines: Array<TimeSeriesLine>;
  /** Dimensions matching the filter; at most 20 are returned as lines. */
  matched: Scalars['Int']['output'];
};

export type TimeSeriesLinesInput = {
  from: Scalars['DateTime']['input'];
  /** Bar width in seconds. */
  intervalSeconds: Scalars['Int']['input'];
  labels?: InputMaybe<Array<TimeSeriesLabelFilterInput>>;
  seriesId: Scalars['UUID']['input'];
  /** Read the series as shown on this stream. Without it, only the owner can read it. */
  streamId?: InputMaybe<Scalars['ID']['input']>;
  to: Scalars['DateTime']['input'];
};

export type TimeSeriesReadInput = {
  labels?: InputMaybe<Array<TimeSeriesLabelFilterInput>>;
  seriesId: Scalars['UUID']['input'];
  /** Read the series as shown on this stream. Without it, only the owner can read it. */
  streamId?: InputMaybe<Scalars['ID']['input']>;
};

export type TimeSeriesRoute = {
  __typename?: 'TimeSeriesRoute';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  seriesId: Scalars['ID']['output'];
  stream?: Maybe<Stream>;
  streamId: Scalars['ID']['output'];
};

export type ToggleFollowUserButton = {
  __typename?: 'ToggleFollowUserButton';
  user: User;
};

export type TranslateFastInference = {
  __typename?: 'TranslateFastInference';
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  input: Scalars['String']['output'];
  inputChars: Scalars['Int']['output'];
  l: Scalars['String']['output'];
  latencyMs: Scalars['Int']['output'];
  outcome: TranslateFastInferenceOutcome;
  postId?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  t: Scalars['String']['output'];
  ts: Scalars['String']['output'];
};

export const TranslateFastInferenceOutcome = {
  Error: 'error',
  Ok: 'ok'
} as const;

export type TranslateFastInferenceOutcome = typeof TranslateFastInferenceOutcome[keyof typeof TranslateFastInferenceOutcome];
export type TranslateFastInferencePage = {
  __typename?: 'TranslateFastInferencePage';
  items: Array<TranslateFastInference>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type TranslateFastInferencesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['String']['input'];
  lang?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
};

export type TranslateFastLangCount = {
  __typename?: 'TranslateFastLangCount';
  approxP95Ms?: Maybe<Scalars['Float']['output']>;
  avgMs?: Maybe<Scalars['Float']['output']>;
  bandGt3000: Scalars['Int']['output'];
  bandLe100: Scalars['Int']['output'];
  bandLe250: Scalars['Int']['output'];
  bandLe500: Scalars['Int']['output'];
  bandLe1000: Scalars['Int']['output'];
  bandLe2000: Scalars['Int']['output'];
  bandLe3000: Scalars['Int']['output'];
  busy: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  lang: Scalars['String']['output'];
  sumMs?: Maybe<Scalars['Float']['output']>;
};

export type TranslateFastLatencyBucket = {
  __typename?: 'TranslateFastLatencyBucket';
  approxP95Ms?: Maybe<Scalars['Float']['output']>;
  avgMs: Scalars['Float']['output'];
  bucketStart: Scalars['String']['output'];
  busy: Scalars['Int']['output'];
  capacity: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  decode: Scalars['Int']['output'];
  english: Scalars['Int']['output'];
  error: Scalars['Int']['output'];
  languages: Array<TranslateFastLangCount>;
  maxMs: Scalars['Int']['output'];
  ok: Scalars['Int']['output'];
  reasons: Array<TranslateFastReasonStat>;
  skipped: Scalars['Int']['output'];
  timeout: Scalars['Int']['output'];
  translated: Scalars['Int']['output'];
  unexpected: Scalars['Int']['output'];
};

export type TranslateFastReasonStat = {
  __typename?: 'TranslateFastReasonStat';
  approxP95Ms?: Maybe<Scalars['Float']['output']>;
  avgMs?: Maybe<Scalars['Float']['output']>;
  bandGt3000: Scalars['Int']['output'];
  bandLe100: Scalars['Int']['output'];
  bandLe250: Scalars['Int']['output'];
  bandLe500: Scalars['Int']['output'];
  bandLe1000: Scalars['Int']['output'];
  bandLe2000: Scalars['Int']['output'];
  bandLe3000: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
  sumMs?: Maybe<Scalars['Float']['output']>;
};

export type TwttrApiAccount = {
  __typename?: 'TwttrApiAccount';
  availableTwttrApiUnits: Scalars['BigInt']['output'];
  consumedTwttrApiUnits: Scalars['BigInt']['output'];
  purchasedTwttrApiUnits: Scalars['BigInt']['output'];
};

export type TwttrApiBillingPortalSession = {
  __typename?: 'TwttrApiBillingPortalSession';
  url: Scalars['String']['output'];
};

export type TwttrApiCheckout = {
  __typename?: 'TwttrApiCheckout';
  url: Scalars['String']['output'];
};

export type TwttrApiCheckoutPriceInput = {
  priceId: Scalars['String']['input'];
  /** The quantity of the price to checkout */
  quantity: Scalars['Int']['input'];
};

export type TwttrApiPrice = {
  __typename?: 'TwttrApiPrice';
  amount: Scalars['Int']['output'];
  apiRequestUnits: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['String']['output'];
  interval?: Maybe<Scalars['String']['output']>;
  product: StripeProduct;
  type: StripePriceType;
};

export type TwttrApiSubscription = {
  __typename?: 'TwttrApiSubscription';
  ended_at?: Maybe<Scalars['DateTime']['output']>;
  price: TwttrApiPrice;
  start_date: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
};

export type TypeaheadInput = {
  followingFirst: Scalars['Boolean']['input'];
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  ownedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  paidFirst: Scalars['Boolean']['input'];
  /** When set, only streams with this polymatcherEnabled value are returned. Other result types are unchanged. Omitted applies no filter. A missing value counts as false. */
  polymatcherEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  text: Scalars['String']['input'];
  type: Array<SearchType>;
};

export type TypeaheadResult = {
  __typename?: 'TypeaheadResult';
  offset?: Maybe<Scalars['Int']['output']>;
  streamPackages: Array<StreamPackage>;
  streams: Array<Stream>;
  users: Array<User>;
};

export type UpdateApiKeyPermissionsInput = {
  apiKeyId: Scalars['ID']['input'];
  canPublish: Array<Scalars['ID']['input']>;
  canRead: ApiKeyCanReadInput;
};

export type UpdateCustomCollectionInput = {
  filters: CustomCollectionFilterConfigInput;
  highlights?: InputMaybe<CustomCollectionHighlightInput>;
  id: Scalars['ULID']['input'];
  matchingSourcesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  sources: Array<CustomCollectionSourceInput>;
  streamDeckId: Scalars['ULID']['input'];
};

export type UpdateGeneralNotificationSettingsInput = {
  notificationType: NotificationType;
  value: Scalars['Boolean']['input'];
};

export type UpdateSettingsInput = {
  notifications: NotificationsSettingsInput;
};

export type UpdateSourceInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['String']['input']>;
  sourceId: Scalars['ID']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateStreamDeckInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateStreamInput = {
  apiAccessEnabled: Scalars['Boolean']['input'];
  customTargetsData?: InputMaybe<CustomTargetsDataInput>;
  /** @deprecated use descriptionJson instead */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionJson?: InputMaybe<Scalars['LexicalJSON']['input']>;
  image?: InputMaybe<S3ObjectInput>;
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
  packageOnly?: Scalars['Boolean']['input'];
  paidData?: InputMaybe<PaidDataInput>;
  streamCategory: StreamCategory;
};

export type UpdateStreamPackageInput = {
  badge: StreamPackageBadge;
  /** @deprecated use descriptionJson instead */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionJson?: InputMaybe<Scalars['LexicalJSON']['input']>;
  includedStreamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
  paidData?: InputMaybe<PaidDataInput>;
  streamPackageCategory: StreamCategory;
};

export type UpdateTerminalSettingsInput = {
  enableOrderbookDoubleClick?: InputMaybe<Scalars['Boolean']['input']>;
  marketBlacklist?: InputMaybe<Array<MarketBlacklistEntryInput>>;
  marketGreenlist?: InputMaybe<Array<MarketBlacklistEntryInput>>;
  marketGreenlistMode?: InputMaybe<MarketGreenlistMode>;
  maxSlippage?: InputMaybe<Scalars['Float']['input']>;
  onboardingCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  streamListFilters?: InputMaybe<StreamListFiltersInput>;
};

export type UpdateTerminalTabInput = {
  configuration?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  avatar?: InputMaybe<S3ObjectInput>;
  backgroundImage?: InputMaybe<S3ObjectInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  isOnboardingFinished?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingProgress?: InputMaybe<Array<OnboardingType>>;
};

export type UpsertEnrichmentServiceInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxResponseBytes?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  secretArn?: InputMaybe<Scalars['String']['input']>;
  timeoutMs?: InputMaybe<Scalars['Int']['input']>;
  url: Scalars['String']['input'];
};

export type User = Node & {
  __typename?: 'User';
  acceptedPrivacyPolicy: Scalars['Boolean']['output'];
  acceptedTermsOfService: Scalars['Boolean']['output'];
  avatar?: Maybe<S3Object>;
  backgroundImage?: Maybe<S3Object>;
  bio?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  followersCount: Scalars['Int']['output'];
  following: Scalars['Boolean']['output'];
  followingCount: Scalars['Int']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isHighlighted: Scalars['Boolean']['output'];
  /** Whether the user is in the EarlyAccess_Terminal GrowthBook group. Admin-only, null otherwise. */
  isInEarlyAccessTerminal?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the news-deck GrowthBook flag is on for the user. Admin-only, null otherwise. */
  newsDeckEnabled?: Maybe<Scalars['Boolean']['output']>;
  organizationMembership?: Maybe<OrganizationMembership>;
  protectedFields?: Maybe<ProtectedUserFields>;
  streams: StreamsPage;
  terminalAccessRequested?: Maybe<Scalars['Boolean']['output']>;
  username: Scalars['String']['output'];
  xComHandle?: Maybe<Scalars['String']['output']>;
};


export type UserStreamsArgs = {
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type UserCoupon = {
  __typename?: 'UserCoupon';
  couponId: Scalars['String']['output'];
  discountAmountCents: Scalars['Int']['output'];
  streamId: Scalars['String']['output'];
  usedAt?: Maybe<Scalars['String']['output']>;
};

export type UserSettings = {
  __typename?: 'UserSettings';
  notifications: NotificationsSettings;
};

export type UserStreamsInput = {
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type UsersByNameInput = {
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type UsersListInput = {
  hasStripe?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};

export type UsersPage = {
  __typename?: 'UsersPage';
  items: Array<User>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export const ValidationStatus = {
  Accepted: 'ACCEPTED',
  Rejected: 'REJECTED'
} as const;

export type ValidationStatus = typeof ValidationStatus[keyof typeof ValidationStatus];
export const VoxAccessRequestStatus = {
  Approved: 'APPROVED',
  Pending: 'PENDING',
  Rejected: 'REJECTED'
} as const;

export type VoxAccessRequestStatus = typeof VoxAccessRequestStatus[keyof typeof VoxAccessRequestStatus];
export const VoxActionType = {
  Message: 'MESSAGE',
  Reaction: 'REACTION'
} as const;

export type VoxActionType = typeof VoxActionType[keyof typeof VoxActionType];
export type VoxConfig = {
  __typename?: 'VoxConfig';
  freeAllowedUsernames: Array<Scalars['String']['output']>;
  prices: Array<VoxPrice>;
  trialAllowedUsernames: Array<Scalars['String']['output']>;
};

export const VoxContentType = {
  Contact: 'CONTACT',
  File: 'FILE',
  Geo: 'GEO',
  Media: 'MEDIA',
  Poll: 'POLL',
  Sticker: 'STICKER',
  Text: 'TEXT',
  Video: 'VIDEO',
  Voice: 'VOICE'
} as const;

export type VoxContentType = typeof VoxContentType[keyof typeof VoxContentType];
export type VoxFullAccessRequest = {
  __typename?: 'VoxFullAccessRequest';
  confirmMonitoringAudit: Scalars['Boolean']['output'];
  confirmNoMisuse: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  investigationDetails: Scalars['String']['output'];
  legitimateNeed: Scalars['String']['output'];
  purpose: Scalars['String']['output'];
  reviewedAt?: Maybe<Scalars['String']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  status: VoxAccessRequestStatus;
  useCase: Scalars['String']['output'];
  user?: Maybe<User>;
};

export type VoxFullAccessRequestsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<VoxAccessRequestStatus>;
};

export type VoxFullAccessRequestsPage = {
  __typename?: 'VoxFullAccessRequestsPage';
  items: Array<VoxFullAccessRequest>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export const VoxHistoryEvent = {
  TextSearch: 'TEXT_SEARCH',
  UserNamesSearch: 'USER_NAMES_SEARCH',
  UserSearch: 'USER_SEARCH'
} as const;

export type VoxHistoryEvent = typeof VoxHistoryEvent[keyof typeof VoxHistoryEvent];
export type VoxHistoryInput = {
  event: VoxHistoryEvent;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type VoxHistoryObject = {
  __typename?: 'VoxHistoryObject';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  query: Scalars['String']['output'];
  user: User;
};

export type VoxHistoryPage = {
  __typename?: 'VoxHistoryPage';
  items: Array<VoxHistoryObject>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export const VoxMessageType = {
  Comment: 'COMMENT',
  Post: 'POST'
} as const;

export type VoxMessageType = typeof VoxMessageType[keyof typeof VoxMessageType];
export const VoxMessageTypeInput = {
  All: 'ALL',
  Comment: 'COMMENT',
  Post: 'POST'
} as const;

export type VoxMessageTypeInput = typeof VoxMessageTypeInput[keyof typeof VoxMessageTypeInput];
export type VoxPrice = {
  __typename?: 'VoxPrice';
  amount: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['String']['output'];
  interval: Scalars['String']['output'];
  productType: VoxProductType;
};

export const VoxProductType = {
  Free: 'FREE',
  Full: 'FULL',
  Trial: 'TRIAL'
} as const;

export type VoxProductType = typeof VoxProductType[keyof typeof VoxProductType];
export const VoxSearchTextOrder = {
  Asc: 'ASC',
  Desc: 'DESC'
} as const;

export type VoxSearchTextOrder = typeof VoxSearchTextOrder[keyof typeof VoxSearchTextOrder];
export type VoxSubscription = {
  __typename?: 'VoxSubscription';
  active: Scalars['Boolean']['output'];
  cancelAt?: Maybe<Scalars['String']['output']>;
  fullAccessApproved: Scalars['Boolean']['output'];
  productType: VoxProductType;
  textSearch: VoxProductType;
  userNameSearch: VoxProductType;
  userSearch: VoxProductType;
};

export type VoxTextSearchInput = {
  excludeForwards?: Scalars['Boolean']['input'];
  excludeGroupsIds?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  messageType?: VoxMessageTypeInput;
  offset?: Scalars['Int']['input'];
  onlyWithMedia?: Scalars['Boolean']['input'];
  order?: VoxSearchTextOrder;
  query: Scalars['String']['input'];
  stream?: Scalars['Boolean']['input'];
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type VoxTextSearchResult = {
  __typename?: 'VoxTextSearchResult';
  count: Scalars['Int']['output'];
  messages: Array<VoxTextSearchResultEntry>;
};

export type VoxTextSearchResultEntry = {
  __typename?: 'VoxTextSearchResultEntry';
  date: Scalars['String']['output'];
  groupAlias: Scalars['String']['output'];
  groupId: Scalars['String']['output'];
  groupMembersCount: Scalars['String']['output'];
  groupName: Scalars['String']['output'];
  groupUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  messageUrl: Scalars['String']['output'];
  relatedGroupAlias: Scalars['String']['output'];
  relatedGroupId: Scalars['String']['output'];
  relatedGroupMembersCount: Scalars['String']['output'];
  relatedGroupName: Scalars['String']['output'];
  relatedGroupUrl: Scalars['String']['output'];
  text: Scalars['String']['output'];
  type: VoxMessageType;
  userAlias: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type VoxUserNamesEntry = {
  __typename?: 'VoxUserNamesEntry';
  alias: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type VoxUserNamesSearchResult = {
  __typename?: 'VoxUserNamesSearchResult';
  names: Array<VoxUserNamesEntry>;
};

export type VoxUserProfileActionMessage = {
  __typename?: 'VoxUserProfileActionMessage';
  content: VoxUserProfileMessageContent;
  date: Scalars['String']['output'];
  groupId: Scalars['String']['output'];
  type: VoxActionType;
};

export type VoxUserProfileActionUnion = VoxUserProfileActionMessage | VoxUserProfileReaction;

export type VoxUserProfileGroup = {
  __typename?: 'VoxUserProfileGroup';
  about: Scalars['String']['output'];
  alias: Scalars['String']['output'];
  id: Scalars['String']['output'];
  membersCount: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type VoxUserProfileMessageContent = {
  __typename?: 'VoxUserProfileMessageContent';
  contentType: VoxContentType;
  id: Scalars['String']['output'];
  reactions: Array<VoxUserProfileReaction>;
  text: Scalars['String']['output'];
};

export type VoxUserProfileReaction = {
  __typename?: 'VoxUserProfileReaction';
  count: Scalars['Int']['output'];
  emoji: Scalars['String']['output'];
};

export type VoxUserProfileResult = {
  __typename?: 'VoxUserProfileResult';
  about: Scalars['String']['output'];
  accountAge: Scalars['Int']['output'];
  actions: Array<VoxUserProfileActionUnion>;
  alias: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  groups: Array<VoxUserProfileGroup>;
  id: Scalars['String']['output'];
  pic: Scalars['String']['output'];
};

export type VoxUserSearchInput = {
  userNameOrUserId: Scalars['String']['input'];
};
